/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelCaseFilterInput = {
  id?: ModelIDInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  historySummary?: ModelStringInput | null,
  planSummary?: ModelStringInput | null,
  communicationSummary?: ModelStringInput | null,
  overviewSummary?: ModelStringInput | null,
  typedNotes?: ModelStringInput | null,
  caseTemplateId?: ModelIDInput | null,
  templateData?: ModelStringInput | null,
  lID?: ModelIDInput | null,
  pID?: ModelIDInput | null,
  groups?: ModelStringInput | null,
  owners?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelCaseFilterInput | null > | null,
  or?: Array< ModelCaseFilterInput | null > | null,
  not?: ModelCaseFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelCaseConnection = {
  __typename: "ModelCaseConnection",
  items:  Array<Case | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type Case = {
  __typename: "Case",
  id: string,
  title: string,
  description?: string | null,
  historySummary?: string | null,
  planSummary?: string | null,
  communicationSummary?: string | null,
  overviewSummary?: string | null,
  typedNotes?: string | null,
  template?: Template | null,
  caseTemplateId?: string | null,
  templateData?: string | null,
  location?: Location | null,
  lID?: string | null,
  patient?: Patient | null,
  pID?: string | null,
  details?: ModelDetailsConnection | null,
  recordings?: ModelRecordingConnection | null,
  groups?: Array< string | null > | null,
  owners?: Array< string | null > | null,
  updatedAt: string,
  createdAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type Template = {
  __typename: "Template",
  id: string,
  name: string,
  pinned?: boolean | null,
  archived?: boolean | null,
  advanced?: boolean | null,
  location?: Location | null,
  lID: string,
  sections?: ModelTemplateSectionConnection | null,
  sectionOrder?: Array< string | null > | null,
  subsections?: ModelTemplateSubsectionConnection | null,
  fields?: ModelTemplateFieldConnection | null,
  textboxes?: ModelTemplateTextboxConnection | null,
  owners?: Array< string | null > | null,
  updatedAt: string,
  createdAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type Location = {
  __typename: "Location",
  id: string,
  name: string,
  address?: string | null,
  patients?: ModelPatientConnection | null,
  cases?: ModelCaseConnection | null,
  templates?: ModelTemplateConnection | null,
  recordings?: ModelRecordingConnection | null,
  billingcodes?: ModelBillingCodesConnection | null,
  groupUsers?: string | null,
  groupAdmins?: string | null,
  groups?: Array< string | null > | null,
  owners?: Array< string | null > | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ModelPatientConnection = {
  __typename: "ModelPatientConnection",
  items:  Array<Patient | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type Patient = {
  __typename: "Patient",
  id: string,
  name: string,
  client?: string | null,
  image?: string | null,
  s3Image?: string | null,
  pinned?: boolean | null,
  archived?: boolean | null,
  location?: Location | null,
  lID: string,
  cases?: ModelCaseConnection | null,
  details?: ModelDetailsConnection | null,
  groups?: Array< string | null > | null,
  owners?: Array< string | null > | null,
  updatedAt: string,
  createdAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ModelDetailsConnection = {
  __typename: "ModelDetailsConnection",
  items:  Array<Details | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type Details = {
  __typename: "Details",
  id: string,
  type?: DetailsType | null,
  text?: string | null,
  summary?: string | null,
  isSummarized?: boolean | null,
  patient?: Patient | null,
  pID: string,
  case?: Case | null,
  cID: string,
  recording?: Recording | null,
  groups?: Array< string | null > | null,
  owners?: Array< string | null > | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
  detailsRecordingId?: string | null,
};

export enum DetailsType {
  HISTORY = "HISTORY",
  EXAM = "EXAM",
  ASSESSMENT = "ASSESSMENT",
  PLAN = "PLAN",
  COMMUNICATION = "COMMUNICATION",
  OTHER = "OTHER",
}


export type Recording = {
  __typename: "Recording",
  id: string,
  name?: string | null,
  storagePath?: string | null,
  useTemplate?: boolean | null,
  duration?: number | null,
  text?: string | null,
  segments?: string | null,
  summary?: string | null,
  location?: Location | null,
  lID?: string | null,
  case?: Case | null,
  cID?: string | null,
  details?: Details | null,
  dID?: string | null,
  owners?: Array< string | null > | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ModelTemplateConnection = {
  __typename: "ModelTemplateConnection",
  items:  Array<Template | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelRecordingConnection = {
  __typename: "ModelRecordingConnection",
  items:  Array<Recording | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelBillingCodesConnection = {
  __typename: "ModelBillingCodesConnection",
  items:  Array<BillingCodes | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type BillingCodes = {
  __typename: "BillingCodes",
  id: string,
  code?: string | null,
  description: string,
  keywords: Array< string | null >,
  price?: number | null,
  location?: Location | null,
  lID: string,
  groups?: Array< string | null > | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ModelTemplateSectionConnection = {
  __typename: "ModelTemplateSectionConnection",
  items:  Array<TemplateSection | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type TemplateSection = {
  __typename: "TemplateSection",
  id: string,
  name: string,
  isSimple?: boolean | null,
  textboxes?: ModelTemplateTextboxConnection | null,
  template?: Template | null,
  tID: string,
  subsections?: ModelTemplateSubsectionConnection | null,
  subsectionOrder?: Array< string | null > | null,
  owners?: Array< string | null > | null,
  updatedAt: string,
  createdAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ModelTemplateTextboxConnection = {
  __typename: "ModelTemplateTextboxConnection",
  items:  Array<TemplateTextbox | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type TemplateTextbox = {
  __typename: "TemplateTextbox",
  id: string,
  value?: string | null,
  section?: TemplateSection | null,
  sID: string,
  template?: Template | null,
  tID: string,
  owners?: Array< string | null > | null,
  updatedAt: string,
  createdAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ModelTemplateSubsectionConnection = {
  __typename: "ModelTemplateSubsectionConnection",
  items:  Array<TemplateSubsection | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type TemplateSubsection = {
  __typename: "TemplateSubsection",
  id: string,
  name: string,
  section?: TemplateSection | null,
  sID: string,
  fields?: ModelTemplateFieldConnection | null,
  fieldOrder?: Array< string | null > | null,
  template?: Template | null,
  tID: string,
  owners?: Array< string | null > | null,
  updatedAt: string,
  createdAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ModelTemplateFieldConnection = {
  __typename: "ModelTemplateFieldConnection",
  items:  Array<TemplateField | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type TemplateField = {
  __typename: "TemplateField",
  id: string,
  name: string,
  value?: string | null,
  subsection?: TemplateSubsection | null,
  ssID: string,
  template?: Template | null,
  tID: string,
  owners?: Array< string | null > | null,
  updatedAt: string,
  createdAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type CreateUserInput = {
  id?: string | null,
  email: string,
  name?: string | null,
  transcriptionTime?: number | null,
  transcriptionsCreated?: number | null,
  casesCreated?: number | null,
  templatesUsed?: number | null,
  currentTranscriptionsCreated?: number | null,
  currentCasesCreated?: number | null,
  currentTemplatesUsed?: number | null,
  storeReviewRequestedAt?: string | null,
  pims?: string | null,
  audioRetentionPeriod?: number | null,
  defaultNormalText?: string | null,
  stripeCustomerId?: string | null,
  groups?: Array< string | null > | null,
  owner?: string | null,
  _version?: number | null,
};

export type ModelUserConditionInput = {
  email?: ModelStringInput | null,
  name?: ModelStringInput | null,
  transcriptionTime?: ModelFloatInput | null,
  transcriptionsCreated?: ModelFloatInput | null,
  casesCreated?: ModelFloatInput | null,
  templatesUsed?: ModelFloatInput | null,
  currentTranscriptionsCreated?: ModelFloatInput | null,
  currentCasesCreated?: ModelFloatInput | null,
  currentTemplatesUsed?: ModelFloatInput | null,
  storeReviewRequestedAt?: ModelStringInput | null,
  pims?: ModelStringInput | null,
  audioRetentionPeriod?: ModelFloatInput | null,
  defaultNormalText?: ModelStringInput | null,
  stripeCustomerId?: ModelStringInput | null,
  groups?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type User = {
  __typename: "User",
  id: string,
  email: string,
  name?: string | null,
  transcriptionTime?: number | null,
  transcriptionsCreated?: number | null,
  casesCreated?: number | null,
  templatesUsed?: number | null,
  currentTranscriptionsCreated?: number | null,
  currentCasesCreated?: number | null,
  currentTemplatesUsed?: number | null,
  storeReviewRequestedAt?: string | null,
  pims?: string | null,
  audioRetentionPeriod?: number | null,
  defaultNormalText?: string | null,
  stripeCustomerId?: string | null,
  groups?: Array< string | null > | null,
  owner?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateUserInput = {
  id: string,
  email?: string | null,
  name?: string | null,
  transcriptionTime?: number | null,
  transcriptionsCreated?: number | null,
  casesCreated?: number | null,
  templatesUsed?: number | null,
  currentTranscriptionsCreated?: number | null,
  currentCasesCreated?: number | null,
  currentTemplatesUsed?: number | null,
  storeReviewRequestedAt?: string | null,
  pims?: string | null,
  audioRetentionPeriod?: number | null,
  defaultNormalText?: string | null,
  stripeCustomerId?: string | null,
  groups?: Array< string | null > | null,
  owner?: string | null,
  _version?: number | null,
};

export type DeleteUserInput = {
  id: string,
  _version?: number | null,
};

export type CreateLocationInput = {
  id?: string | null,
  name: string,
  address?: string | null,
  groupUsers?: string | null,
  groupAdmins?: string | null,
  groups?: Array< string | null > | null,
  owners?: Array< string | null > | null,
  _version?: number | null,
};

export type ModelLocationConditionInput = {
  name?: ModelStringInput | null,
  address?: ModelStringInput | null,
  groupUsers?: ModelStringInput | null,
  groupAdmins?: ModelStringInput | null,
  groups?: ModelStringInput | null,
  owners?: ModelStringInput | null,
  and?: Array< ModelLocationConditionInput | null > | null,
  or?: Array< ModelLocationConditionInput | null > | null,
  not?: ModelLocationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateLocationInput = {
  id: string,
  name?: string | null,
  address?: string | null,
  groupUsers?: string | null,
  groupAdmins?: string | null,
  groups?: Array< string | null > | null,
  owners?: Array< string | null > | null,
  _version?: number | null,
};

export type DeleteLocationInput = {
  id: string,
  _version?: number | null,
};

export type CreatePatientInput = {
  id?: string | null,
  name: string,
  client?: string | null,
  image?: string | null,
  s3Image?: string | null,
  pinned?: boolean | null,
  archived?: boolean | null,
  lID: string,
  groups?: Array< string | null > | null,
  owners?: Array< string | null > | null,
  updatedAt?: string | null,
  _version?: number | null,
};

export type ModelPatientConditionInput = {
  name?: ModelStringInput | null,
  client?: ModelStringInput | null,
  image?: ModelStringInput | null,
  s3Image?: ModelStringInput | null,
  pinned?: ModelBooleanInput | null,
  archived?: ModelBooleanInput | null,
  lID?: ModelIDInput | null,
  groups?: ModelStringInput | null,
  owners?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPatientConditionInput | null > | null,
  or?: Array< ModelPatientConditionInput | null > | null,
  not?: ModelPatientConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
};

export type UpdatePatientInput = {
  id: string,
  name?: string | null,
  client?: string | null,
  image?: string | null,
  s3Image?: string | null,
  pinned?: boolean | null,
  archived?: boolean | null,
  lID?: string | null,
  groups?: Array< string | null > | null,
  owners?: Array< string | null > | null,
  updatedAt?: string | null,
  _version?: number | null,
};

export type DeletePatientInput = {
  id: string,
  _version?: number | null,
};

export type CreateCaseInput = {
  id?: string | null,
  title: string,
  description?: string | null,
  historySummary?: string | null,
  planSummary?: string | null,
  communicationSummary?: string | null,
  overviewSummary?: string | null,
  typedNotes?: string | null,
  caseTemplateId?: string | null,
  templateData?: string | null,
  lID?: string | null,
  pID?: string | null,
  groups?: Array< string | null > | null,
  owners?: Array< string | null > | null,
  updatedAt?: string | null,
  createdAt?: string | null,
  _version?: number | null,
};

export type ModelCaseConditionInput = {
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  historySummary?: ModelStringInput | null,
  planSummary?: ModelStringInput | null,
  communicationSummary?: ModelStringInput | null,
  overviewSummary?: ModelStringInput | null,
  typedNotes?: ModelStringInput | null,
  caseTemplateId?: ModelIDInput | null,
  templateData?: ModelStringInput | null,
  lID?: ModelIDInput | null,
  pID?: ModelIDInput | null,
  groups?: ModelStringInput | null,
  owners?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelCaseConditionInput | null > | null,
  or?: Array< ModelCaseConditionInput | null > | null,
  not?: ModelCaseConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UpdateCaseInput = {
  id: string,
  title?: string | null,
  description?: string | null,
  historySummary?: string | null,
  planSummary?: string | null,
  communicationSummary?: string | null,
  overviewSummary?: string | null,
  typedNotes?: string | null,
  caseTemplateId?: string | null,
  templateData?: string | null,
  lID?: string | null,
  pID?: string | null,
  groups?: Array< string | null > | null,
  owners?: Array< string | null > | null,
  updatedAt?: string | null,
  createdAt?: string | null,
  _version?: number | null,
};

export type DeleteCaseInput = {
  id: string,
  _version?: number | null,
};

export type CreateDetailsInput = {
  id?: string | null,
  type?: DetailsType | null,
  text?: string | null,
  summary?: string | null,
  isSummarized?: boolean | null,
  pID: string,
  cID: string,
  groups?: Array< string | null > | null,
  owners?: Array< string | null > | null,
  _version?: number | null,
  detailsRecordingId?: string | null,
};

export type ModelDetailsConditionInput = {
  type?: ModelDetailsTypeInput | null,
  text?: ModelStringInput | null,
  summary?: ModelStringInput | null,
  isSummarized?: ModelBooleanInput | null,
  pID?: ModelIDInput | null,
  cID?: ModelIDInput | null,
  groups?: ModelStringInput | null,
  owners?: ModelStringInput | null,
  and?: Array< ModelDetailsConditionInput | null > | null,
  or?: Array< ModelDetailsConditionInput | null > | null,
  not?: ModelDetailsConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  detailsRecordingId?: ModelIDInput | null,
};

export type ModelDetailsTypeInput = {
  eq?: DetailsType | null,
  ne?: DetailsType | null,
};

export type UpdateDetailsInput = {
  id: string,
  type?: DetailsType | null,
  text?: string | null,
  summary?: string | null,
  isSummarized?: boolean | null,
  pID?: string | null,
  cID?: string | null,
  groups?: Array< string | null > | null,
  owners?: Array< string | null > | null,
  _version?: number | null,
  detailsRecordingId?: string | null,
};

export type DeleteDetailsInput = {
  id: string,
  _version?: number | null,
};

export type CreateRecordingInput = {
  id?: string | null,
  name?: string | null,
  storagePath?: string | null,
  useTemplate?: boolean | null,
  duration?: number | null,
  text?: string | null,
  segments?: string | null,
  summary?: string | null,
  lID?: string | null,
  cID?: string | null,
  dID?: string | null,
  owners?: Array< string | null > | null,
  _version?: number | null,
};

export type ModelRecordingConditionInput = {
  name?: ModelStringInput | null,
  storagePath?: ModelStringInput | null,
  useTemplate?: ModelBooleanInput | null,
  duration?: ModelFloatInput | null,
  text?: ModelStringInput | null,
  segments?: ModelStringInput | null,
  summary?: ModelStringInput | null,
  lID?: ModelIDInput | null,
  cID?: ModelIDInput | null,
  dID?: ModelIDInput | null,
  owners?: ModelStringInput | null,
  and?: Array< ModelRecordingConditionInput | null > | null,
  or?: Array< ModelRecordingConditionInput | null > | null,
  not?: ModelRecordingConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateRecordingInput = {
  id: string,
  name?: string | null,
  storagePath?: string | null,
  useTemplate?: boolean | null,
  duration?: number | null,
  text?: string | null,
  segments?: string | null,
  summary?: string | null,
  lID?: string | null,
  cID?: string | null,
  dID?: string | null,
  owners?: Array< string | null > | null,
  _version?: number | null,
};

export type DeleteRecordingInput = {
  id: string,
  _version?: number | null,
};

export type CreateBillingCodesInput = {
  id?: string | null,
  code?: string | null,
  description: string,
  keywords: Array< string | null >,
  price?: number | null,
  lID: string,
  groups?: Array< string | null > | null,
  _version?: number | null,
};

export type ModelBillingCodesConditionInput = {
  code?: ModelStringInput | null,
  description?: ModelStringInput | null,
  keywords?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  lID?: ModelIDInput | null,
  groups?: ModelStringInput | null,
  and?: Array< ModelBillingCodesConditionInput | null > | null,
  or?: Array< ModelBillingCodesConditionInput | null > | null,
  not?: ModelBillingCodesConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateBillingCodesInput = {
  id: string,
  code?: string | null,
  description?: string | null,
  keywords?: Array< string | null > | null,
  price?: number | null,
  lID?: string | null,
  groups?: Array< string | null > | null,
  _version?: number | null,
};

export type DeleteBillingCodesInput = {
  id: string,
  _version?: number | null,
};

export type CreateTemplateInput = {
  id?: string | null,
  name: string,
  pinned?: boolean | null,
  archived?: boolean | null,
  advanced?: boolean | null,
  lID: string,
  sectionOrder?: Array< string | null > | null,
  owners?: Array< string | null > | null,
  updatedAt?: string | null,
  _version?: number | null,
};

export type ModelTemplateConditionInput = {
  name?: ModelStringInput | null,
  pinned?: ModelBooleanInput | null,
  archived?: ModelBooleanInput | null,
  advanced?: ModelBooleanInput | null,
  lID?: ModelIDInput | null,
  sectionOrder?: ModelStringInput | null,
  owners?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTemplateConditionInput | null > | null,
  or?: Array< ModelTemplateConditionInput | null > | null,
  not?: ModelTemplateConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
};

export type UpdateTemplateInput = {
  id: string,
  name?: string | null,
  pinned?: boolean | null,
  archived?: boolean | null,
  advanced?: boolean | null,
  lID?: string | null,
  sectionOrder?: Array< string | null > | null,
  owners?: Array< string | null > | null,
  updatedAt?: string | null,
  _version?: number | null,
};

export type DeleteTemplateInput = {
  id: string,
  _version?: number | null,
};

export type CreateTemplateSectionInput = {
  id?: string | null,
  name: string,
  isSimple?: boolean | null,
  tID: string,
  subsectionOrder?: Array< string | null > | null,
  owners?: Array< string | null > | null,
  updatedAt?: string | null,
  _version?: number | null,
};

export type ModelTemplateSectionConditionInput = {
  name?: ModelStringInput | null,
  isSimple?: ModelBooleanInput | null,
  tID?: ModelIDInput | null,
  subsectionOrder?: ModelStringInput | null,
  owners?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTemplateSectionConditionInput | null > | null,
  or?: Array< ModelTemplateSectionConditionInput | null > | null,
  not?: ModelTemplateSectionConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
};

export type UpdateTemplateSectionInput = {
  id: string,
  name?: string | null,
  isSimple?: boolean | null,
  tID?: string | null,
  subsectionOrder?: Array< string | null > | null,
  owners?: Array< string | null > | null,
  updatedAt?: string | null,
  _version?: number | null,
};

export type DeleteTemplateSectionInput = {
  id: string,
  _version?: number | null,
};

export type CreateTemplateTextboxInput = {
  id?: string | null,
  value?: string | null,
  sID: string,
  tID: string,
  owners?: Array< string | null > | null,
  updatedAt?: string | null,
  _version?: number | null,
};

export type ModelTemplateTextboxConditionInput = {
  value?: ModelStringInput | null,
  sID?: ModelIDInput | null,
  tID?: ModelIDInput | null,
  owners?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTemplateTextboxConditionInput | null > | null,
  or?: Array< ModelTemplateTextboxConditionInput | null > | null,
  not?: ModelTemplateTextboxConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
};

export type UpdateTemplateTextboxInput = {
  id: string,
  value?: string | null,
  sID?: string | null,
  tID?: string | null,
  owners?: Array< string | null > | null,
  updatedAt?: string | null,
  _version?: number | null,
};

export type DeleteTemplateTextboxInput = {
  id: string,
  _version?: number | null,
};

export type CreateTemplateSubsectionInput = {
  id?: string | null,
  name: string,
  sID: string,
  fieldOrder?: Array< string | null > | null,
  tID: string,
  owners?: Array< string | null > | null,
  updatedAt?: string | null,
  _version?: number | null,
};

export type ModelTemplateSubsectionConditionInput = {
  name?: ModelStringInput | null,
  sID?: ModelIDInput | null,
  fieldOrder?: ModelStringInput | null,
  tID?: ModelIDInput | null,
  owners?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTemplateSubsectionConditionInput | null > | null,
  or?: Array< ModelTemplateSubsectionConditionInput | null > | null,
  not?: ModelTemplateSubsectionConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
};

export type UpdateTemplateSubsectionInput = {
  id: string,
  name?: string | null,
  sID?: string | null,
  fieldOrder?: Array< string | null > | null,
  tID?: string | null,
  owners?: Array< string | null > | null,
  updatedAt?: string | null,
  _version?: number | null,
};

export type DeleteTemplateSubsectionInput = {
  id: string,
  _version?: number | null,
};

export type CreateTemplateFieldInput = {
  id?: string | null,
  name: string,
  value?: string | null,
  ssID: string,
  tID: string,
  owners?: Array< string | null > | null,
  updatedAt?: string | null,
  _version?: number | null,
};

export type ModelTemplateFieldConditionInput = {
  name?: ModelStringInput | null,
  value?: ModelStringInput | null,
  ssID?: ModelIDInput | null,
  tID?: ModelIDInput | null,
  owners?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTemplateFieldConditionInput | null > | null,
  or?: Array< ModelTemplateFieldConditionInput | null > | null,
  not?: ModelTemplateFieldConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
};

export type UpdateTemplateFieldInput = {
  id: string,
  name?: string | null,
  value?: string | null,
  ssID?: string | null,
  tID?: string | null,
  owners?: Array< string | null > | null,
  updatedAt?: string | null,
  _version?: number | null,
};

export type DeleteTemplateFieldInput = {
  id: string,
  _version?: number | null,
};

export type ModelPatientFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  client?: ModelStringInput | null,
  image?: ModelStringInput | null,
  s3Image?: ModelStringInput | null,
  pinned?: ModelBooleanInput | null,
  archived?: ModelBooleanInput | null,
  lID?: ModelIDInput | null,
  groups?: ModelStringInput | null,
  owners?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelPatientFilterInput | null > | null,
  or?: Array< ModelPatientFilterInput | null > | null,
  not?: ModelPatientFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  email?: ModelStringInput | null,
  name?: ModelStringInput | null,
  transcriptionTime?: ModelFloatInput | null,
  transcriptionsCreated?: ModelFloatInput | null,
  casesCreated?: ModelFloatInput | null,
  templatesUsed?: ModelFloatInput | null,
  currentTranscriptionsCreated?: ModelFloatInput | null,
  currentCasesCreated?: ModelFloatInput | null,
  currentTemplatesUsed?: ModelFloatInput | null,
  storeReviewRequestedAt?: ModelStringInput | null,
  pims?: ModelStringInput | null,
  audioRetentionPeriod?: ModelFloatInput | null,
  defaultNormalText?: ModelStringInput | null,
  stripeCustomerId?: ModelStringInput | null,
  groups?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelLocationFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  address?: ModelStringInput | null,
  groupUsers?: ModelStringInput | null,
  groupAdmins?: ModelStringInput | null,
  groups?: ModelStringInput | null,
  owners?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLocationFilterInput | null > | null,
  or?: Array< ModelLocationFilterInput | null > | null,
  not?: ModelLocationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelLocationConnection = {
  __typename: "ModelLocationConnection",
  items:  Array<Location | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelDetailsFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelDetailsTypeInput | null,
  text?: ModelStringInput | null,
  summary?: ModelStringInput | null,
  isSummarized?: ModelBooleanInput | null,
  pID?: ModelIDInput | null,
  cID?: ModelIDInput | null,
  groups?: ModelStringInput | null,
  owners?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDetailsFilterInput | null > | null,
  or?: Array< ModelDetailsFilterInput | null > | null,
  not?: ModelDetailsFilterInput | null,
  _deleted?: ModelBooleanInput | null,
  detailsRecordingId?: ModelIDInput | null,
};

export type ModelRecordingFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  storagePath?: ModelStringInput | null,
  useTemplate?: ModelBooleanInput | null,
  duration?: ModelFloatInput | null,
  text?: ModelStringInput | null,
  segments?: ModelStringInput | null,
  summary?: ModelStringInput | null,
  lID?: ModelIDInput | null,
  cID?: ModelIDInput | null,
  dID?: ModelIDInput | null,
  owners?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelRecordingFilterInput | null > | null,
  or?: Array< ModelRecordingFilterInput | null > | null,
  not?: ModelRecordingFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelBillingCodesFilterInput = {
  id?: ModelIDInput | null,
  code?: ModelStringInput | null,
  description?: ModelStringInput | null,
  keywords?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  lID?: ModelIDInput | null,
  groups?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelBillingCodesFilterInput | null > | null,
  or?: Array< ModelBillingCodesFilterInput | null > | null,
  not?: ModelBillingCodesFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTemplateFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  pinned?: ModelBooleanInput | null,
  archived?: ModelBooleanInput | null,
  advanced?: ModelBooleanInput | null,
  lID?: ModelIDInput | null,
  sectionOrder?: ModelStringInput | null,
  owners?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelTemplateFilterInput | null > | null,
  or?: Array< ModelTemplateFilterInput | null > | null,
  not?: ModelTemplateFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTemplateSectionFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  isSimple?: ModelBooleanInput | null,
  tID?: ModelIDInput | null,
  subsectionOrder?: ModelStringInput | null,
  owners?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelTemplateSectionFilterInput | null > | null,
  or?: Array< ModelTemplateSectionFilterInput | null > | null,
  not?: ModelTemplateSectionFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTemplateTextboxFilterInput = {
  id?: ModelIDInput | null,
  value?: ModelStringInput | null,
  sID?: ModelIDInput | null,
  tID?: ModelIDInput | null,
  owners?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelTemplateTextboxFilterInput | null > | null,
  or?: Array< ModelTemplateTextboxFilterInput | null > | null,
  not?: ModelTemplateTextboxFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTemplateSubsectionFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  sID?: ModelIDInput | null,
  fieldOrder?: ModelStringInput | null,
  tID?: ModelIDInput | null,
  owners?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelTemplateSubsectionFilterInput | null > | null,
  or?: Array< ModelTemplateSubsectionFilterInput | null > | null,
  not?: ModelTemplateSubsectionFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTemplateFieldFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  value?: ModelStringInput | null,
  ssID?: ModelIDInput | null,
  tID?: ModelIDInput | null,
  owners?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelTemplateFieldFilterInput | null > | null,
  or?: Array< ModelTemplateFieldFilterInput | null > | null,
  not?: ModelTemplateFieldFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionUserFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  email?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  transcriptionTime?: ModelSubscriptionFloatInput | null,
  transcriptionsCreated?: ModelSubscriptionFloatInput | null,
  casesCreated?: ModelSubscriptionFloatInput | null,
  templatesUsed?: ModelSubscriptionFloatInput | null,
  currentTranscriptionsCreated?: ModelSubscriptionFloatInput | null,
  currentCasesCreated?: ModelSubscriptionFloatInput | null,
  currentTemplatesUsed?: ModelSubscriptionFloatInput | null,
  storeReviewRequestedAt?: ModelSubscriptionStringInput | null,
  pims?: ModelSubscriptionStringInput | null,
  audioRetentionPeriod?: ModelSubscriptionFloatInput | null,
  defaultNormalText?: ModelSubscriptionStringInput | null,
  stripeCustomerId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
  owner?: ModelStringInput | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionLocationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  address?: ModelSubscriptionStringInput | null,
  groupUsers?: ModelSubscriptionStringInput | null,
  groupAdmins?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLocationFilterInput | null > | null,
  or?: Array< ModelSubscriptionLocationFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
  owners?: ModelStringInput | null,
};

export type ModelSubscriptionPatientFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  client?: ModelSubscriptionStringInput | null,
  image?: ModelSubscriptionStringInput | null,
  s3Image?: ModelSubscriptionStringInput | null,
  pinned?: ModelSubscriptionBooleanInput | null,
  archived?: ModelSubscriptionBooleanInput | null,
  lID?: ModelSubscriptionIDInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPatientFilterInput | null > | null,
  or?: Array< ModelSubscriptionPatientFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
  owners?: ModelStringInput | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionCaseFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  title?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  historySummary?: ModelSubscriptionStringInput | null,
  planSummary?: ModelSubscriptionStringInput | null,
  communicationSummary?: ModelSubscriptionStringInput | null,
  overviewSummary?: ModelSubscriptionStringInput | null,
  typedNotes?: ModelSubscriptionStringInput | null,
  caseTemplateId?: ModelSubscriptionIDInput | null,
  templateData?: ModelSubscriptionStringInput | null,
  lID?: ModelSubscriptionIDInput | null,
  pID?: ModelSubscriptionIDInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCaseFilterInput | null > | null,
  or?: Array< ModelSubscriptionCaseFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
  owners?: ModelStringInput | null,
};

export type ModelSubscriptionDetailsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  text?: ModelSubscriptionStringInput | null,
  summary?: ModelSubscriptionStringInput | null,
  isSummarized?: ModelSubscriptionBooleanInput | null,
  pID?: ModelSubscriptionIDInput | null,
  cID?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDetailsFilterInput | null > | null,
  or?: Array< ModelSubscriptionDetailsFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
  detailsRecordingId?: ModelSubscriptionIDInput | null,
  owners?: ModelStringInput | null,
};

export type ModelSubscriptionRecordingFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  storagePath?: ModelSubscriptionStringInput | null,
  useTemplate?: ModelSubscriptionBooleanInput | null,
  duration?: ModelSubscriptionFloatInput | null,
  text?: ModelSubscriptionStringInput | null,
  segments?: ModelSubscriptionStringInput | null,
  summary?: ModelSubscriptionStringInput | null,
  lID?: ModelSubscriptionIDInput | null,
  cID?: ModelSubscriptionIDInput | null,
  dID?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionRecordingFilterInput | null > | null,
  or?: Array< ModelSubscriptionRecordingFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
  owners?: ModelStringInput | null,
};

export type ModelSubscriptionBillingCodesFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  code?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  keywords?: ModelSubscriptionStringInput | null,
  price?: ModelSubscriptionFloatInput | null,
  lID?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionBillingCodesFilterInput | null > | null,
  or?: Array< ModelSubscriptionBillingCodesFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionTemplateFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  pinned?: ModelSubscriptionBooleanInput | null,
  archived?: ModelSubscriptionBooleanInput | null,
  advanced?: ModelSubscriptionBooleanInput | null,
  lID?: ModelSubscriptionIDInput | null,
  sectionOrder?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTemplateFilterInput | null > | null,
  or?: Array< ModelSubscriptionTemplateFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
  owners?: ModelStringInput | null,
};

export type ModelSubscriptionTemplateSectionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  isSimple?: ModelSubscriptionBooleanInput | null,
  tID?: ModelSubscriptionIDInput | null,
  subsectionOrder?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTemplateSectionFilterInput | null > | null,
  or?: Array< ModelSubscriptionTemplateSectionFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
  owners?: ModelStringInput | null,
};

export type ModelSubscriptionTemplateTextboxFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  value?: ModelSubscriptionStringInput | null,
  sID?: ModelSubscriptionIDInput | null,
  tID?: ModelSubscriptionIDInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTemplateTextboxFilterInput | null > | null,
  or?: Array< ModelSubscriptionTemplateTextboxFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
  owners?: ModelStringInput | null,
};

export type ModelSubscriptionTemplateSubsectionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  sID?: ModelSubscriptionIDInput | null,
  fieldOrder?: ModelSubscriptionStringInput | null,
  tID?: ModelSubscriptionIDInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTemplateSubsectionFilterInput | null > | null,
  or?: Array< ModelSubscriptionTemplateSubsectionFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
  owners?: ModelStringInput | null,
};

export type ModelSubscriptionTemplateFieldFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  value?: ModelSubscriptionStringInput | null,
  ssID?: ModelSubscriptionIDInput | null,
  tID?: ModelSubscriptionIDInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTemplateFieldFilterInput | null > | null,
  or?: Array< ModelSubscriptionTemplateFieldFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
  owners?: ModelStringInput | null,
};

export type CasesByPIDAndCreatedAtShallowQueryVariables = {
  pID: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CasesByPIDAndCreatedAtShallowQuery = {
  casesByPIDAndCreatedAt?:  {
    __typename: "ModelCaseConnection",
    items:  Array< {
      __typename: "Case",
      id: string,
      title: string,
      description?: string | null,
      historySummary?: string | null,
      planSummary?: string | null,
      communicationSummary?: string | null,
      overviewSummary?: string | null,
      templateData?: string | null,
      typedNotes?: string | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        items:  Array< {
          __typename: "Recording",
          id: string,
          name?: string | null,
          storagePath?: string | null,
          text?: string | null,
          summary?: string | null,
          segments?: string | null,
          lID?: string | null,
          cID?: string | null,
          owners?: Array< string | null > | null,
          createdAt: string,
          _version: number,
          _deleted?: boolean | null,
        } | null >,
      } | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        items:  Array< {
          __typename: "Details",
          id: string,
          type?: DetailsType | null,
          text?: string | null,
          summary?: string | null,
          isSummarized?: boolean | null,
          pID: string,
          cID: string,
          groups?: Array< string | null > | null,
          owners?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      caseTemplateId?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetCaseShallowQueryVariables = {
  id: string,
};

export type GetCaseShallowQuery = {
  getCase?:  {
    __typename: "Case",
    id: string,
    title: string,
    description?: string | null,
    historySummary?: string | null,
    planSummary?: string | null,
    communicationSummary?: string | null,
    overviewSummary?: string | null,
    templateData?: string | null,
    typedNotes?: string | null,
    recordings?:  {
      __typename: "ModelRecordingConnection",
      items:  Array< {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        text?: string | null,
        summary?: string | null,
        segments?: string | null,
        lID?: string | null,
        cID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
      } | null >,
    } | null,
    details?:  {
      __typename: "ModelDetailsConnection",
      items:  Array< {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        patient?:  {
          __typename: "Patient",
          id: string,
          name: string,
          client?: string | null,
          image?: string | null,
          s3Image?: string | null,
          lID: string,
          groups?: Array< string | null > | null,
          owners?: Array< string | null > | null,
          updatedAt: string,
          createdAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null,
        pID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    caseTemplateId?: string | null,
  } | null,
};

export type GetPatientShallowQueryVariables = {
  id: string,
};

export type GetPatientShallowQuery = {
  getPatient?:  {
    __typename: "Patient",
    id: string,
    name: string,
    client?: string | null,
    image?: string | null,
    s3Image?: string | null,
    lID: string,
    cases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        templateData?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        caseTemplateId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type GetTemplateShallowQueryVariables = {
  id: string,
};

export type GetTemplateShallowQuery = {
  getTemplate?:  {
    __typename: "Template",
    id: string,
    name: string,
    owners?: Array< string | null > | null,
    createdAt: string,
    sectionOrder?: Array< string | null > | null,
    advanced?: boolean | null,
    updatedAt: string,
    _version: number,
    _lastChangedAt: number,
    _deleted?: boolean | null,
    sections?:  {
      __typename: "ModelTemplateSectionConnection",
      items:  Array< {
        __typename: "TemplateSection",
        name: string,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        _version: number,
        createdAt: string,
        id: string,
        isSimple?: boolean | null,
        textboxes?:  {
          __typename: "ModelTemplateTextboxConnection",
          items:  Array< {
            __typename: "TemplateTextbox",
            id: string,
            value?: string | null,
            _version: number,
            createdAt: string,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null >,
        } | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        subsectionOrder?: Array< string | null > | null,
        subsections?:  {
          __typename: "ModelTemplateSubsectionConnection",
          items:  Array< {
            __typename: "TemplateSubsection",
            _version: number,
            owners?: Array< string | null > | null,
            createdAt: string,
            _deleted?: boolean | null,
            _lastChangedAt: number,
            fieldOrder?: Array< string | null > | null,
            id: string,
            name: string,
            sID: string,
            fields?:  {
              __typename: "ModelTemplateFieldConnection",
              items:  Array< {
                __typename: "TemplateField",
                _deleted?: boolean | null,
                _lastChangedAt: number,
                createdAt: string,
                _version: number,
                id: string,
                name: string,
                owners?: Array< string | null > | null,
                updatedAt: string,
                value?: string | null,
              } | null >,
            } | null,
          } | null >,
        } | null,
      } | null >,
    } | null,
  } | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    id: string,
    email: string,
    name?: string | null,
    transcriptionTime?: number | null,
    transcriptionsCreated?: number | null,
    casesCreated?: number | null,
    templatesUsed?: number | null,
    currentTranscriptionsCreated?: number | null,
    currentCasesCreated?: number | null,
    currentTemplatesUsed?: number | null,
    storeReviewRequestedAt?: string | null,
    pims?: string | null,
    audioRetentionPeriod?: number | null,
    defaultNormalText?: string | null,
    stripeCustomerId?: string | null,
    groups?: Array< string | null > | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    id: string,
    email: string,
    name?: string | null,
    transcriptionTime?: number | null,
    transcriptionsCreated?: number | null,
    casesCreated?: number | null,
    templatesUsed?: number | null,
    currentTranscriptionsCreated?: number | null,
    currentCasesCreated?: number | null,
    currentTemplatesUsed?: number | null,
    storeReviewRequestedAt?: string | null,
    pims?: string | null,
    audioRetentionPeriod?: number | null,
    defaultNormalText?: string | null,
    stripeCustomerId?: string | null,
    groups?: Array< string | null > | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    id: string,
    email: string,
    name?: string | null,
    transcriptionTime?: number | null,
    transcriptionsCreated?: number | null,
    casesCreated?: number | null,
    templatesUsed?: number | null,
    currentTranscriptionsCreated?: number | null,
    currentCasesCreated?: number | null,
    currentTemplatesUsed?: number | null,
    storeReviewRequestedAt?: string | null,
    pims?: string | null,
    audioRetentionPeriod?: number | null,
    defaultNormalText?: string | null,
    stripeCustomerId?: string | null,
    groups?: Array< string | null > | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateLocationMutationVariables = {
  input: CreateLocationInput,
  condition?: ModelLocationConditionInput | null,
};

export type CreateLocationMutation = {
  createLocation?:  {
    __typename: "Location",
    id: string,
    name: string,
    address?: string | null,
    patients?:  {
      __typename: "ModelPatientConnection",
      items:  Array< {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    templates?:  {
      __typename: "ModelTemplateConnection",
      items:  Array< {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    recordings?:  {
      __typename: "ModelRecordingConnection",
      items:  Array< {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    billingcodes?:  {
      __typename: "ModelBillingCodesConnection",
      items:  Array< {
        __typename: "BillingCodes",
        id: string,
        code?: string | null,
        description: string,
        keywords: Array< string | null >,
        price?: number | null,
        lID: string,
        groups?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groupUsers?: string | null,
    groupAdmins?: string | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateLocationMutationVariables = {
  input: UpdateLocationInput,
  condition?: ModelLocationConditionInput | null,
};

export type UpdateLocationMutation = {
  updateLocation?:  {
    __typename: "Location",
    id: string,
    name: string,
    address?: string | null,
    patients?:  {
      __typename: "ModelPatientConnection",
      items:  Array< {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    templates?:  {
      __typename: "ModelTemplateConnection",
      items:  Array< {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    recordings?:  {
      __typename: "ModelRecordingConnection",
      items:  Array< {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    billingcodes?:  {
      __typename: "ModelBillingCodesConnection",
      items:  Array< {
        __typename: "BillingCodes",
        id: string,
        code?: string | null,
        description: string,
        keywords: Array< string | null >,
        price?: number | null,
        lID: string,
        groups?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groupUsers?: string | null,
    groupAdmins?: string | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteLocationMutationVariables = {
  input: DeleteLocationInput,
  condition?: ModelLocationConditionInput | null,
};

export type DeleteLocationMutation = {
  deleteLocation?:  {
    __typename: "Location",
    id: string,
    name: string,
    address?: string | null,
    patients?:  {
      __typename: "ModelPatientConnection",
      items:  Array< {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    templates?:  {
      __typename: "ModelTemplateConnection",
      items:  Array< {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    recordings?:  {
      __typename: "ModelRecordingConnection",
      items:  Array< {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    billingcodes?:  {
      __typename: "ModelBillingCodesConnection",
      items:  Array< {
        __typename: "BillingCodes",
        id: string,
        code?: string | null,
        description: string,
        keywords: Array< string | null >,
        price?: number | null,
        lID: string,
        groups?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groupUsers?: string | null,
    groupAdmins?: string | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreatePatientMutationVariables = {
  input: CreatePatientInput,
  condition?: ModelPatientConditionInput | null,
};

export type CreatePatientMutation = {
  createPatient?:  {
    __typename: "Patient",
    id: string,
    name: string,
    client?: string | null,
    image?: string | null,
    s3Image?: string | null,
    pinned?: boolean | null,
    archived?: boolean | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    cases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    details?:  {
      __typename: "ModelDetailsConnection",
      items:  Array< {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdatePatientMutationVariables = {
  input: UpdatePatientInput,
  condition?: ModelPatientConditionInput | null,
};

export type UpdatePatientMutation = {
  updatePatient?:  {
    __typename: "Patient",
    id: string,
    name: string,
    client?: string | null,
    image?: string | null,
    s3Image?: string | null,
    pinned?: boolean | null,
    archived?: boolean | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    cases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    details?:  {
      __typename: "ModelDetailsConnection",
      items:  Array< {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeletePatientMutationVariables = {
  input: DeletePatientInput,
  condition?: ModelPatientConditionInput | null,
};

export type DeletePatientMutation = {
  deletePatient?:  {
    __typename: "Patient",
    id: string,
    name: string,
    client?: string | null,
    image?: string | null,
    s3Image?: string | null,
    pinned?: boolean | null,
    archived?: boolean | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    cases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    details?:  {
      __typename: "ModelDetailsConnection",
      items:  Array< {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateCaseMutationVariables = {
  input: CreateCaseInput,
  condition?: ModelCaseConditionInput | null,
};

export type CreateCaseMutation = {
  createCase?:  {
    __typename: "Case",
    id: string,
    title: string,
    description?: string | null,
    historySummary?: string | null,
    planSummary?: string | null,
    communicationSummary?: string | null,
    overviewSummary?: string | null,
    typedNotes?: string | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    caseTemplateId?: string | null,
    templateData?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID?: string | null,
    patient?:  {
      __typename: "Patient",
      id: string,
      name: string,
      client?: string | null,
      image?: string | null,
      s3Image?: string | null,
      pinned?: boolean | null,
      archived?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    pID?: string | null,
    details?:  {
      __typename: "ModelDetailsConnection",
      items:  Array< {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    recordings?:  {
      __typename: "ModelRecordingConnection",
      items:  Array< {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateCaseMutationVariables = {
  input: UpdateCaseInput,
  condition?: ModelCaseConditionInput | null,
};

export type UpdateCaseMutation = {
  updateCase?:  {
    __typename: "Case",
    id: string,
    title: string,
    description?: string | null,
    historySummary?: string | null,
    planSummary?: string | null,
    communicationSummary?: string | null,
    overviewSummary?: string | null,
    typedNotes?: string | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    caseTemplateId?: string | null,
    templateData?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID?: string | null,
    patient?:  {
      __typename: "Patient",
      id: string,
      name: string,
      client?: string | null,
      image?: string | null,
      s3Image?: string | null,
      pinned?: boolean | null,
      archived?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    pID?: string | null,
    details?:  {
      __typename: "ModelDetailsConnection",
      items:  Array< {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    recordings?:  {
      __typename: "ModelRecordingConnection",
      items:  Array< {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteCaseMutationVariables = {
  input: DeleteCaseInput,
  condition?: ModelCaseConditionInput | null,
};

export type DeleteCaseMutation = {
  deleteCase?:  {
    __typename: "Case",
    id: string,
    title: string,
    description?: string | null,
    historySummary?: string | null,
    planSummary?: string | null,
    communicationSummary?: string | null,
    overviewSummary?: string | null,
    typedNotes?: string | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    caseTemplateId?: string | null,
    templateData?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID?: string | null,
    patient?:  {
      __typename: "Patient",
      id: string,
      name: string,
      client?: string | null,
      image?: string | null,
      s3Image?: string | null,
      pinned?: boolean | null,
      archived?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    pID?: string | null,
    details?:  {
      __typename: "ModelDetailsConnection",
      items:  Array< {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    recordings?:  {
      __typename: "ModelRecordingConnection",
      items:  Array< {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateDetailsMutationVariables = {
  input: CreateDetailsInput,
  condition?: ModelDetailsConditionInput | null,
};

export type CreateDetailsMutation = {
  createDetails?:  {
    __typename: "Details",
    id: string,
    type?: DetailsType | null,
    text?: string | null,
    summary?: string | null,
    isSummarized?: boolean | null,
    patient?:  {
      __typename: "Patient",
      id: string,
      name: string,
      client?: string | null,
      image?: string | null,
      s3Image?: string | null,
      pinned?: boolean | null,
      archived?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    pID: string,
    case?:  {
      __typename: "Case",
      id: string,
      title: string,
      description?: string | null,
      historySummary?: string | null,
      planSummary?: string | null,
      communicationSummary?: string | null,
      overviewSummary?: string | null,
      typedNotes?: string | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      caseTemplateId?: string | null,
      templateData?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID?: string | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    cID: string,
    recording?:  {
      __typename: "Recording",
      id: string,
      name?: string | null,
      storagePath?: string | null,
      useTemplate?: boolean | null,
      duration?: number | null,
      text?: string | null,
      segments?: string | null,
      summary?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID?: string | null,
      details?:  {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null,
      dID?: string | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    detailsRecordingId?: string | null,
  } | null,
};

export type UpdateDetailsMutationVariables = {
  input: UpdateDetailsInput,
  condition?: ModelDetailsConditionInput | null,
};

export type UpdateDetailsMutation = {
  updateDetails?:  {
    __typename: "Details",
    id: string,
    type?: DetailsType | null,
    text?: string | null,
    summary?: string | null,
    isSummarized?: boolean | null,
    patient?:  {
      __typename: "Patient",
      id: string,
      name: string,
      client?: string | null,
      image?: string | null,
      s3Image?: string | null,
      pinned?: boolean | null,
      archived?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    pID: string,
    case?:  {
      __typename: "Case",
      id: string,
      title: string,
      description?: string | null,
      historySummary?: string | null,
      planSummary?: string | null,
      communicationSummary?: string | null,
      overviewSummary?: string | null,
      typedNotes?: string | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      caseTemplateId?: string | null,
      templateData?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID?: string | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    cID: string,
    recording?:  {
      __typename: "Recording",
      id: string,
      name?: string | null,
      storagePath?: string | null,
      useTemplate?: boolean | null,
      duration?: number | null,
      text?: string | null,
      segments?: string | null,
      summary?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID?: string | null,
      details?:  {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null,
      dID?: string | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    detailsRecordingId?: string | null,
  } | null,
};

export type DeleteDetailsMutationVariables = {
  input: DeleteDetailsInput,
  condition?: ModelDetailsConditionInput | null,
};

export type DeleteDetailsMutation = {
  deleteDetails?:  {
    __typename: "Details",
    id: string,
    type?: DetailsType | null,
    text?: string | null,
    summary?: string | null,
    isSummarized?: boolean | null,
    patient?:  {
      __typename: "Patient",
      id: string,
      name: string,
      client?: string | null,
      image?: string | null,
      s3Image?: string | null,
      pinned?: boolean | null,
      archived?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    pID: string,
    case?:  {
      __typename: "Case",
      id: string,
      title: string,
      description?: string | null,
      historySummary?: string | null,
      planSummary?: string | null,
      communicationSummary?: string | null,
      overviewSummary?: string | null,
      typedNotes?: string | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      caseTemplateId?: string | null,
      templateData?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID?: string | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    cID: string,
    recording?:  {
      __typename: "Recording",
      id: string,
      name?: string | null,
      storagePath?: string | null,
      useTemplate?: boolean | null,
      duration?: number | null,
      text?: string | null,
      segments?: string | null,
      summary?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID?: string | null,
      details?:  {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null,
      dID?: string | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    detailsRecordingId?: string | null,
  } | null,
};

export type CreateRecordingMutationVariables = {
  input: CreateRecordingInput,
  condition?: ModelRecordingConditionInput | null,
};

export type CreateRecordingMutation = {
  createRecording?:  {
    __typename: "Recording",
    id: string,
    name?: string | null,
    storagePath?: string | null,
    useTemplate?: boolean | null,
    duration?: number | null,
    text?: string | null,
    segments?: string | null,
    summary?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID?: string | null,
    case?:  {
      __typename: "Case",
      id: string,
      title: string,
      description?: string | null,
      historySummary?: string | null,
      planSummary?: string | null,
      communicationSummary?: string | null,
      overviewSummary?: string | null,
      typedNotes?: string | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      caseTemplateId?: string | null,
      templateData?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID?: string | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    cID?: string | null,
    details?:  {
      __typename: "Details",
      id: string,
      type?: DetailsType | null,
      text?: string | null,
      summary?: string | null,
      isSummarized?: boolean | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID: string,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID: string,
      recording?:  {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      detailsRecordingId?: string | null,
    } | null,
    dID?: string | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateRecordingMutationVariables = {
  input: UpdateRecordingInput,
  condition?: ModelRecordingConditionInput | null,
};

export type UpdateRecordingMutation = {
  updateRecording?:  {
    __typename: "Recording",
    id: string,
    name?: string | null,
    storagePath?: string | null,
    useTemplate?: boolean | null,
    duration?: number | null,
    text?: string | null,
    segments?: string | null,
    summary?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID?: string | null,
    case?:  {
      __typename: "Case",
      id: string,
      title: string,
      description?: string | null,
      historySummary?: string | null,
      planSummary?: string | null,
      communicationSummary?: string | null,
      overviewSummary?: string | null,
      typedNotes?: string | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      caseTemplateId?: string | null,
      templateData?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID?: string | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    cID?: string | null,
    details?:  {
      __typename: "Details",
      id: string,
      type?: DetailsType | null,
      text?: string | null,
      summary?: string | null,
      isSummarized?: boolean | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID: string,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID: string,
      recording?:  {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      detailsRecordingId?: string | null,
    } | null,
    dID?: string | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteRecordingMutationVariables = {
  input: DeleteRecordingInput,
  condition?: ModelRecordingConditionInput | null,
};

export type DeleteRecordingMutation = {
  deleteRecording?:  {
    __typename: "Recording",
    id: string,
    name?: string | null,
    storagePath?: string | null,
    useTemplate?: boolean | null,
    duration?: number | null,
    text?: string | null,
    segments?: string | null,
    summary?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID?: string | null,
    case?:  {
      __typename: "Case",
      id: string,
      title: string,
      description?: string | null,
      historySummary?: string | null,
      planSummary?: string | null,
      communicationSummary?: string | null,
      overviewSummary?: string | null,
      typedNotes?: string | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      caseTemplateId?: string | null,
      templateData?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID?: string | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    cID?: string | null,
    details?:  {
      __typename: "Details",
      id: string,
      type?: DetailsType | null,
      text?: string | null,
      summary?: string | null,
      isSummarized?: boolean | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID: string,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID: string,
      recording?:  {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      detailsRecordingId?: string | null,
    } | null,
    dID?: string | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateBillingCodesMutationVariables = {
  input: CreateBillingCodesInput,
  condition?: ModelBillingCodesConditionInput | null,
};

export type CreateBillingCodesMutation = {
  createBillingCodes?:  {
    __typename: "BillingCodes",
    id: string,
    code?: string | null,
    description: string,
    keywords: Array< string | null >,
    price?: number | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    groups?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateBillingCodesMutationVariables = {
  input: UpdateBillingCodesInput,
  condition?: ModelBillingCodesConditionInput | null,
};

export type UpdateBillingCodesMutation = {
  updateBillingCodes?:  {
    __typename: "BillingCodes",
    id: string,
    code?: string | null,
    description: string,
    keywords: Array< string | null >,
    price?: number | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    groups?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteBillingCodesMutationVariables = {
  input: DeleteBillingCodesInput,
  condition?: ModelBillingCodesConditionInput | null,
};

export type DeleteBillingCodesMutation = {
  deleteBillingCodes?:  {
    __typename: "BillingCodes",
    id: string,
    code?: string | null,
    description: string,
    keywords: Array< string | null >,
    price?: number | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    groups?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTemplateMutationVariables = {
  input: CreateTemplateInput,
  condition?: ModelTemplateConditionInput | null,
};

export type CreateTemplateMutation = {
  createTemplate?:  {
    __typename: "Template",
    id: string,
    name: string,
    pinned?: boolean | null,
    archived?: boolean | null,
    advanced?: boolean | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    sections?:  {
      __typename: "ModelTemplateSectionConnection",
      items:  Array< {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    sectionOrder?: Array< string | null > | null,
    subsections?:  {
      __typename: "ModelTemplateSubsectionConnection",
      items:  Array< {
        __typename: "TemplateSubsection",
        id: string,
        name: string,
        sID: string,
        fieldOrder?: Array< string | null > | null,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    fields?:  {
      __typename: "ModelTemplateFieldConnection",
      items:  Array< {
        __typename: "TemplateField",
        id: string,
        name: string,
        value?: string | null,
        ssID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    textboxes?:  {
      __typename: "ModelTemplateTextboxConnection",
      items:  Array< {
        __typename: "TemplateTextbox",
        id: string,
        value?: string | null,
        sID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTemplateMutationVariables = {
  input: UpdateTemplateInput,
  condition?: ModelTemplateConditionInput | null,
};

export type UpdateTemplateMutation = {
  updateTemplate?:  {
    __typename: "Template",
    id: string,
    name: string,
    pinned?: boolean | null,
    archived?: boolean | null,
    advanced?: boolean | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    sections?:  {
      __typename: "ModelTemplateSectionConnection",
      items:  Array< {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    sectionOrder?: Array< string | null > | null,
    subsections?:  {
      __typename: "ModelTemplateSubsectionConnection",
      items:  Array< {
        __typename: "TemplateSubsection",
        id: string,
        name: string,
        sID: string,
        fieldOrder?: Array< string | null > | null,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    fields?:  {
      __typename: "ModelTemplateFieldConnection",
      items:  Array< {
        __typename: "TemplateField",
        id: string,
        name: string,
        value?: string | null,
        ssID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    textboxes?:  {
      __typename: "ModelTemplateTextboxConnection",
      items:  Array< {
        __typename: "TemplateTextbox",
        id: string,
        value?: string | null,
        sID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTemplateMutationVariables = {
  input: DeleteTemplateInput,
  condition?: ModelTemplateConditionInput | null,
};

export type DeleteTemplateMutation = {
  deleteTemplate?:  {
    __typename: "Template",
    id: string,
    name: string,
    pinned?: boolean | null,
    archived?: boolean | null,
    advanced?: boolean | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    sections?:  {
      __typename: "ModelTemplateSectionConnection",
      items:  Array< {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    sectionOrder?: Array< string | null > | null,
    subsections?:  {
      __typename: "ModelTemplateSubsectionConnection",
      items:  Array< {
        __typename: "TemplateSubsection",
        id: string,
        name: string,
        sID: string,
        fieldOrder?: Array< string | null > | null,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    fields?:  {
      __typename: "ModelTemplateFieldConnection",
      items:  Array< {
        __typename: "TemplateField",
        id: string,
        name: string,
        value?: string | null,
        ssID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    textboxes?:  {
      __typename: "ModelTemplateTextboxConnection",
      items:  Array< {
        __typename: "TemplateTextbox",
        id: string,
        value?: string | null,
        sID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTemplateSectionMutationVariables = {
  input: CreateTemplateSectionInput,
  condition?: ModelTemplateSectionConditionInput | null,
};

export type CreateTemplateSectionMutation = {
  createTemplateSection?:  {
    __typename: "TemplateSection",
    id: string,
    name: string,
    isSimple?: boolean | null,
    textboxes?:  {
      __typename: "ModelTemplateTextboxConnection",
      items:  Array< {
        __typename: "TemplateTextbox",
        id: string,
        value?: string | null,
        sID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    subsections?:  {
      __typename: "ModelTemplateSubsectionConnection",
      items:  Array< {
        __typename: "TemplateSubsection",
        id: string,
        name: string,
        sID: string,
        fieldOrder?: Array< string | null > | null,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    subsectionOrder?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTemplateSectionMutationVariables = {
  input: UpdateTemplateSectionInput,
  condition?: ModelTemplateSectionConditionInput | null,
};

export type UpdateTemplateSectionMutation = {
  updateTemplateSection?:  {
    __typename: "TemplateSection",
    id: string,
    name: string,
    isSimple?: boolean | null,
    textboxes?:  {
      __typename: "ModelTemplateTextboxConnection",
      items:  Array< {
        __typename: "TemplateTextbox",
        id: string,
        value?: string | null,
        sID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    subsections?:  {
      __typename: "ModelTemplateSubsectionConnection",
      items:  Array< {
        __typename: "TemplateSubsection",
        id: string,
        name: string,
        sID: string,
        fieldOrder?: Array< string | null > | null,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    subsectionOrder?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTemplateSectionMutationVariables = {
  input: DeleteTemplateSectionInput,
  condition?: ModelTemplateSectionConditionInput | null,
};

export type DeleteTemplateSectionMutation = {
  deleteTemplateSection?:  {
    __typename: "TemplateSection",
    id: string,
    name: string,
    isSimple?: boolean | null,
    textboxes?:  {
      __typename: "ModelTemplateTextboxConnection",
      items:  Array< {
        __typename: "TemplateTextbox",
        id: string,
        value?: string | null,
        sID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    subsections?:  {
      __typename: "ModelTemplateSubsectionConnection",
      items:  Array< {
        __typename: "TemplateSubsection",
        id: string,
        name: string,
        sID: string,
        fieldOrder?: Array< string | null > | null,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    subsectionOrder?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTemplateTextboxMutationVariables = {
  input: CreateTemplateTextboxInput,
  condition?: ModelTemplateTextboxConditionInput | null,
};

export type CreateTemplateTextboxMutation = {
  createTemplateTextbox?:  {
    __typename: "TemplateTextbox",
    id: string,
    value?: string | null,
    section?:  {
      __typename: "TemplateSection",
      id: string,
      name: string,
      isSimple?: boolean | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      subsectionOrder?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sID: string,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTemplateTextboxMutationVariables = {
  input: UpdateTemplateTextboxInput,
  condition?: ModelTemplateTextboxConditionInput | null,
};

export type UpdateTemplateTextboxMutation = {
  updateTemplateTextbox?:  {
    __typename: "TemplateTextbox",
    id: string,
    value?: string | null,
    section?:  {
      __typename: "TemplateSection",
      id: string,
      name: string,
      isSimple?: boolean | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      subsectionOrder?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sID: string,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTemplateTextboxMutationVariables = {
  input: DeleteTemplateTextboxInput,
  condition?: ModelTemplateTextboxConditionInput | null,
};

export type DeleteTemplateTextboxMutation = {
  deleteTemplateTextbox?:  {
    __typename: "TemplateTextbox",
    id: string,
    value?: string | null,
    section?:  {
      __typename: "TemplateSection",
      id: string,
      name: string,
      isSimple?: boolean | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      subsectionOrder?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sID: string,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTemplateSubsectionMutationVariables = {
  input: CreateTemplateSubsectionInput,
  condition?: ModelTemplateSubsectionConditionInput | null,
};

export type CreateTemplateSubsectionMutation = {
  createTemplateSubsection?:  {
    __typename: "TemplateSubsection",
    id: string,
    name: string,
    section?:  {
      __typename: "TemplateSection",
      id: string,
      name: string,
      isSimple?: boolean | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      subsectionOrder?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sID: string,
    fields?:  {
      __typename: "ModelTemplateFieldConnection",
      items:  Array< {
        __typename: "TemplateField",
        id: string,
        name: string,
        value?: string | null,
        ssID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    fieldOrder?: Array< string | null > | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTemplateSubsectionMutationVariables = {
  input: UpdateTemplateSubsectionInput,
  condition?: ModelTemplateSubsectionConditionInput | null,
};

export type UpdateTemplateSubsectionMutation = {
  updateTemplateSubsection?:  {
    __typename: "TemplateSubsection",
    id: string,
    name: string,
    section?:  {
      __typename: "TemplateSection",
      id: string,
      name: string,
      isSimple?: boolean | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      subsectionOrder?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sID: string,
    fields?:  {
      __typename: "ModelTemplateFieldConnection",
      items:  Array< {
        __typename: "TemplateField",
        id: string,
        name: string,
        value?: string | null,
        ssID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    fieldOrder?: Array< string | null > | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTemplateSubsectionMutationVariables = {
  input: DeleteTemplateSubsectionInput,
  condition?: ModelTemplateSubsectionConditionInput | null,
};

export type DeleteTemplateSubsectionMutation = {
  deleteTemplateSubsection?:  {
    __typename: "TemplateSubsection",
    id: string,
    name: string,
    section?:  {
      __typename: "TemplateSection",
      id: string,
      name: string,
      isSimple?: boolean | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      subsectionOrder?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sID: string,
    fields?:  {
      __typename: "ModelTemplateFieldConnection",
      items:  Array< {
        __typename: "TemplateField",
        id: string,
        name: string,
        value?: string | null,
        ssID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    fieldOrder?: Array< string | null > | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTemplateFieldMutationVariables = {
  input: CreateTemplateFieldInput,
  condition?: ModelTemplateFieldConditionInput | null,
};

export type CreateTemplateFieldMutation = {
  createTemplateField?:  {
    __typename: "TemplateField",
    id: string,
    name: string,
    value?: string | null,
    subsection?:  {
      __typename: "TemplateSubsection",
      id: string,
      name: string,
      section?:  {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sID: string,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fieldOrder?: Array< string | null > | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ssID: string,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTemplateFieldMutationVariables = {
  input: UpdateTemplateFieldInput,
  condition?: ModelTemplateFieldConditionInput | null,
};

export type UpdateTemplateFieldMutation = {
  updateTemplateField?:  {
    __typename: "TemplateField",
    id: string,
    name: string,
    value?: string | null,
    subsection?:  {
      __typename: "TemplateSubsection",
      id: string,
      name: string,
      section?:  {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sID: string,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fieldOrder?: Array< string | null > | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ssID: string,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTemplateFieldMutationVariables = {
  input: DeleteTemplateFieldInput,
  condition?: ModelTemplateFieldConditionInput | null,
};

export type DeleteTemplateFieldMutation = {
  deleteTemplateField?:  {
    __typename: "TemplateField",
    id: string,
    name: string,
    value?: string | null,
    subsection?:  {
      __typename: "TemplateSubsection",
      id: string,
      name: string,
      section?:  {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sID: string,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fieldOrder?: Array< string | null > | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ssID: string,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type PatientsByLIDAndUpdatedAtShallowQueryVariables = {
  lID: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPatientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PatientsByLIDAndUpdatedAtShallowQuery = {
  patientsByLIDAndUpdatedAt?:  {
    __typename: "ModelPatientConnection",
    items:  Array< {
      __typename: "Patient",
      id: string,
      name: string,
      client?: string | null,
      image?: string | null,
      s3Image?: string | null,
      lID: string,
      cases?:  {
        __typename: "ModelCaseConnection",
        items:  Array< {
          __typename: "Case",
          id: string,
          title: string,
          description?: string | null,
          historySummary?: string | null,
          planSummary?: string | null,
          communicationSummary?: string | null,
          overviewSummary?: string | null,
          templateData?: string | null,
          pID?: string | null,
          groups?: Array< string | null > | null,
          owners?: Array< string | null > | null,
          updatedAt: string,
          createdAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          caseTemplateId?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    email: string,
    name?: string | null,
    transcriptionTime?: number | null,
    transcriptionsCreated?: number | null,
    casesCreated?: number | null,
    templatesUsed?: number | null,
    currentTranscriptionsCreated?: number | null,
    currentCasesCreated?: number | null,
    currentTemplatesUsed?: number | null,
    storeReviewRequestedAt?: string | null,
    pims?: string | null,
    audioRetentionPeriod?: number | null,
    defaultNormalText?: string | null,
    stripeCustomerId?: string | null,
    groups?: Array< string | null > | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email: string,
      name?: string | null,
      transcriptionTime?: number | null,
      transcriptionsCreated?: number | null,
      casesCreated?: number | null,
      templatesUsed?: number | null,
      currentTranscriptionsCreated?: number | null,
      currentCasesCreated?: number | null,
      currentTemplatesUsed?: number | null,
      storeReviewRequestedAt?: string | null,
      pims?: string | null,
      audioRetentionPeriod?: number | null,
      defaultNormalText?: string | null,
      stripeCustomerId?: string | null,
      groups?: Array< string | null > | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUsersQuery = {
  syncUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email: string,
      name?: string | null,
      transcriptionTime?: number | null,
      transcriptionsCreated?: number | null,
      casesCreated?: number | null,
      templatesUsed?: number | null,
      currentTranscriptionsCreated?: number | null,
      currentCasesCreated?: number | null,
      currentTemplatesUsed?: number | null,
      storeReviewRequestedAt?: string | null,
      pims?: string | null,
      audioRetentionPeriod?: number | null,
      defaultNormalText?: string | null,
      stripeCustomerId?: string | null,
      groups?: Array< string | null > | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetLocationQueryVariables = {
  id: string,
};

export type GetLocationQuery = {
  getLocation?:  {
    __typename: "Location",
    id: string,
    name: string,
    address?: string | null,
    patients?:  {
      __typename: "ModelPatientConnection",
      items:  Array< {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    templates?:  {
      __typename: "ModelTemplateConnection",
      items:  Array< {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    recordings?:  {
      __typename: "ModelRecordingConnection",
      items:  Array< {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    billingcodes?:  {
      __typename: "ModelBillingCodesConnection",
      items:  Array< {
        __typename: "BillingCodes",
        id: string,
        code?: string | null,
        description: string,
        keywords: Array< string | null >,
        price?: number | null,
        lID: string,
        groups?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groupUsers?: string | null,
    groupAdmins?: string | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListLocationsQueryVariables = {
  filter?: ModelLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLocationsQuery = {
  listLocations?:  {
    __typename: "ModelLocationConnection",
    items:  Array< {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncLocationsQueryVariables = {
  filter?: ModelLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncLocationsQuery = {
  syncLocations?:  {
    __typename: "ModelLocationConnection",
    items:  Array< {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetPatientQueryVariables = {
  id: string,
};

export type GetPatientQuery = {
  getPatient?:  {
    __typename: "Patient",
    id: string,
    name: string,
    client?: string | null,
    image?: string | null,
    s3Image?: string | null,
    pinned?: boolean | null,
    archived?: boolean | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    cases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    details?:  {
      __typename: "ModelDetailsConnection",
      items:  Array< {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListPatientsQueryVariables = {
  filter?: ModelPatientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPatientsQuery = {
  listPatients?:  {
    __typename: "ModelPatientConnection",
    items:  Array< {
      __typename: "Patient",
      id: string,
      name: string,
      client?: string | null,
      image?: string | null,
      s3Image?: string | null,
      pinned?: boolean | null,
      archived?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncPatientsQueryVariables = {
  filter?: ModelPatientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncPatientsQuery = {
  syncPatients?:  {
    __typename: "ModelPatientConnection",
    items:  Array< {
      __typename: "Patient",
      id: string,
      name: string,
      client?: string | null,
      image?: string | null,
      s3Image?: string | null,
      pinned?: boolean | null,
      archived?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type PatientsByLIDAndUpdatedAtQueryVariables = {
  lID: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPatientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PatientsByLIDAndUpdatedAtQuery = {
  patientsByLIDAndUpdatedAt?:  {
    __typename: "ModelPatientConnection",
    items:  Array< {
      __typename: "Patient",
      id: string,
      name: string,
      client?: string | null,
      image?: string | null,
      s3Image?: string | null,
      pinned?: boolean | null,
      archived?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetCaseQueryVariables = {
  id: string,
};

export type GetCaseQuery = {
  getCase?:  {
    __typename: "Case",
    id: string,
    title: string,
    description?: string | null,
    historySummary?: string | null,
    planSummary?: string | null,
    communicationSummary?: string | null,
    overviewSummary?: string | null,
    typedNotes?: string | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    caseTemplateId?: string | null,
    templateData?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID?: string | null,
    patient?:  {
      __typename: "Patient",
      id: string,
      name: string,
      client?: string | null,
      image?: string | null,
      s3Image?: string | null,
      pinned?: boolean | null,
      archived?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    pID?: string | null,
    details?:  {
      __typename: "ModelDetailsConnection",
      items:  Array< {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    recordings?:  {
      __typename: "ModelRecordingConnection",
      items:  Array< {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListCasesQueryVariables = {
  filter?: ModelCaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCasesQuery = {
  listCases?:  {
    __typename: "ModelCaseConnection",
    items:  Array< {
      __typename: "Case",
      id: string,
      title: string,
      description?: string | null,
      historySummary?: string | null,
      planSummary?: string | null,
      communicationSummary?: string | null,
      overviewSummary?: string | null,
      typedNotes?: string | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      caseTemplateId?: string | null,
      templateData?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID?: string | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncCasesQueryVariables = {
  filter?: ModelCaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncCasesQuery = {
  syncCases?:  {
    __typename: "ModelCaseConnection",
    items:  Array< {
      __typename: "Case",
      id: string,
      title: string,
      description?: string | null,
      historySummary?: string | null,
      planSummary?: string | null,
      communicationSummary?: string | null,
      overviewSummary?: string | null,
      typedNotes?: string | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      caseTemplateId?: string | null,
      templateData?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID?: string | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type CasesByLIDAndUpdatedAtQueryVariables = {
  lID: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CasesByLIDAndUpdatedAtQuery = {
  casesByLIDAndUpdatedAt?:  {
    __typename: "ModelCaseConnection",
    items:  Array< {
      __typename: "Case",
      id: string,
      title: string,
      description?: string | null,
      historySummary?: string | null,
      planSummary?: string | null,
      communicationSummary?: string | null,
      overviewSummary?: string | null,
      typedNotes?: string | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      caseTemplateId?: string | null,
      templateData?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID?: string | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type CasesByPIDAndCreatedAtQueryVariables = {
  pID: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CasesByPIDAndCreatedAtQuery = {
  casesByPIDAndCreatedAt?:  {
    __typename: "ModelCaseConnection",
    items:  Array< {
      __typename: "Case",
      id: string,
      title: string,
      description?: string | null,
      historySummary?: string | null,
      planSummary?: string | null,
      communicationSummary?: string | null,
      overviewSummary?: string | null,
      typedNotes?: string | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      caseTemplateId?: string | null,
      templateData?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID?: string | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetDetailsQueryVariables = {
  id: string,
};

export type GetDetailsQuery = {
  getDetails?:  {
    __typename: "Details",
    id: string,
    type?: DetailsType | null,
    text?: string | null,
    summary?: string | null,
    isSummarized?: boolean | null,
    patient?:  {
      __typename: "Patient",
      id: string,
      name: string,
      client?: string | null,
      image?: string | null,
      s3Image?: string | null,
      pinned?: boolean | null,
      archived?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    pID: string,
    case?:  {
      __typename: "Case",
      id: string,
      title: string,
      description?: string | null,
      historySummary?: string | null,
      planSummary?: string | null,
      communicationSummary?: string | null,
      overviewSummary?: string | null,
      typedNotes?: string | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      caseTemplateId?: string | null,
      templateData?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID?: string | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    cID: string,
    recording?:  {
      __typename: "Recording",
      id: string,
      name?: string | null,
      storagePath?: string | null,
      useTemplate?: boolean | null,
      duration?: number | null,
      text?: string | null,
      segments?: string | null,
      summary?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID?: string | null,
      details?:  {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null,
      dID?: string | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    detailsRecordingId?: string | null,
  } | null,
};

export type ListDetailsQueryVariables = {
  filter?: ModelDetailsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDetailsQuery = {
  listDetails?:  {
    __typename: "ModelDetailsConnection",
    items:  Array< {
      __typename: "Details",
      id: string,
      type?: DetailsType | null,
      text?: string | null,
      summary?: string | null,
      isSummarized?: boolean | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID: string,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID: string,
      recording?:  {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      detailsRecordingId?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncDetailsQueryVariables = {
  filter?: ModelDetailsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncDetailsQuery = {
  syncDetails?:  {
    __typename: "ModelDetailsConnection",
    items:  Array< {
      __typename: "Details",
      id: string,
      type?: DetailsType | null,
      text?: string | null,
      summary?: string | null,
      isSummarized?: boolean | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID: string,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID: string,
      recording?:  {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      detailsRecordingId?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type DetailsByPIDQueryVariables = {
  pID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDetailsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DetailsByPIDQuery = {
  detailsByPID?:  {
    __typename: "ModelDetailsConnection",
    items:  Array< {
      __typename: "Details",
      id: string,
      type?: DetailsType | null,
      text?: string | null,
      summary?: string | null,
      isSummarized?: boolean | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID: string,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID: string,
      recording?:  {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      detailsRecordingId?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type DetailsByCIDQueryVariables = {
  cID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDetailsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DetailsByCIDQuery = {
  detailsByCID?:  {
    __typename: "ModelDetailsConnection",
    items:  Array< {
      __typename: "Details",
      id: string,
      type?: DetailsType | null,
      text?: string | null,
      summary?: string | null,
      isSummarized?: boolean | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID: string,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID: string,
      recording?:  {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      detailsRecordingId?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetRecordingQueryVariables = {
  id: string,
};

export type GetRecordingQuery = {
  getRecording?:  {
    __typename: "Recording",
    id: string,
    name?: string | null,
    storagePath?: string | null,
    useTemplate?: boolean | null,
    duration?: number | null,
    text?: string | null,
    segments?: string | null,
    summary?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID?: string | null,
    case?:  {
      __typename: "Case",
      id: string,
      title: string,
      description?: string | null,
      historySummary?: string | null,
      planSummary?: string | null,
      communicationSummary?: string | null,
      overviewSummary?: string | null,
      typedNotes?: string | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      caseTemplateId?: string | null,
      templateData?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID?: string | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    cID?: string | null,
    details?:  {
      __typename: "Details",
      id: string,
      type?: DetailsType | null,
      text?: string | null,
      summary?: string | null,
      isSummarized?: boolean | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID: string,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID: string,
      recording?:  {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      detailsRecordingId?: string | null,
    } | null,
    dID?: string | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListRecordingsQueryVariables = {
  filter?: ModelRecordingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRecordingsQuery = {
  listRecordings?:  {
    __typename: "ModelRecordingConnection",
    items:  Array< {
      __typename: "Recording",
      id: string,
      name?: string | null,
      storagePath?: string | null,
      useTemplate?: boolean | null,
      duration?: number | null,
      text?: string | null,
      segments?: string | null,
      summary?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID?: string | null,
      details?:  {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null,
      dID?: string | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncRecordingsQueryVariables = {
  filter?: ModelRecordingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncRecordingsQuery = {
  syncRecordings?:  {
    __typename: "ModelRecordingConnection",
    items:  Array< {
      __typename: "Recording",
      id: string,
      name?: string | null,
      storagePath?: string | null,
      useTemplate?: boolean | null,
      duration?: number | null,
      text?: string | null,
      segments?: string | null,
      summary?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID?: string | null,
      details?:  {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null,
      dID?: string | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type RecordingsByLIDQueryVariables = {
  lID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRecordingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RecordingsByLIDQuery = {
  recordingsByLID?:  {
    __typename: "ModelRecordingConnection",
    items:  Array< {
      __typename: "Recording",
      id: string,
      name?: string | null,
      storagePath?: string | null,
      useTemplate?: boolean | null,
      duration?: number | null,
      text?: string | null,
      segments?: string | null,
      summary?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID?: string | null,
      details?:  {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null,
      dID?: string | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type RecordingsByCIDQueryVariables = {
  cID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRecordingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RecordingsByCIDQuery = {
  recordingsByCID?:  {
    __typename: "ModelRecordingConnection",
    items:  Array< {
      __typename: "Recording",
      id: string,
      name?: string | null,
      storagePath?: string | null,
      useTemplate?: boolean | null,
      duration?: number | null,
      text?: string | null,
      segments?: string | null,
      summary?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID?: string | null,
      details?:  {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null,
      dID?: string | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type RecordingsByDIDQueryVariables = {
  dID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRecordingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RecordingsByDIDQuery = {
  recordingsByDID?:  {
    __typename: "ModelRecordingConnection",
    items:  Array< {
      __typename: "Recording",
      id: string,
      name?: string | null,
      storagePath?: string | null,
      useTemplate?: boolean | null,
      duration?: number | null,
      text?: string | null,
      segments?: string | null,
      summary?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID?: string | null,
      details?:  {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null,
      dID?: string | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetBillingCodesQueryVariables = {
  id: string,
};

export type GetBillingCodesQuery = {
  getBillingCodes?:  {
    __typename: "BillingCodes",
    id: string,
    code?: string | null,
    description: string,
    keywords: Array< string | null >,
    price?: number | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    groups?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListBillingCodesQueryVariables = {
  filter?: ModelBillingCodesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBillingCodesQuery = {
  listBillingCodes?:  {
    __typename: "ModelBillingCodesConnection",
    items:  Array< {
      __typename: "BillingCodes",
      id: string,
      code?: string | null,
      description: string,
      keywords: Array< string | null >,
      price?: number | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      groups?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncBillingCodesQueryVariables = {
  filter?: ModelBillingCodesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncBillingCodesQuery = {
  syncBillingCodes?:  {
    __typename: "ModelBillingCodesConnection",
    items:  Array< {
      __typename: "BillingCodes",
      id: string,
      code?: string | null,
      description: string,
      keywords: Array< string | null >,
      price?: number | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      groups?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type BillingCodesByLIDQueryVariables = {
  lID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelBillingCodesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type BillingCodesByLIDQuery = {
  billingCodesByLID?:  {
    __typename: "ModelBillingCodesConnection",
    items:  Array< {
      __typename: "BillingCodes",
      id: string,
      code?: string | null,
      description: string,
      keywords: Array< string | null >,
      price?: number | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      groups?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTemplateQueryVariables = {
  id: string,
};

export type GetTemplateQuery = {
  getTemplate?:  {
    __typename: "Template",
    id: string,
    name: string,
    pinned?: boolean | null,
    archived?: boolean | null,
    advanced?: boolean | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    sections?:  {
      __typename: "ModelTemplateSectionConnection",
      items:  Array< {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    sectionOrder?: Array< string | null > | null,
    subsections?:  {
      __typename: "ModelTemplateSubsectionConnection",
      items:  Array< {
        __typename: "TemplateSubsection",
        id: string,
        name: string,
        sID: string,
        fieldOrder?: Array< string | null > | null,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    fields?:  {
      __typename: "ModelTemplateFieldConnection",
      items:  Array< {
        __typename: "TemplateField",
        id: string,
        name: string,
        value?: string | null,
        ssID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    textboxes?:  {
      __typename: "ModelTemplateTextboxConnection",
      items:  Array< {
        __typename: "TemplateTextbox",
        id: string,
        value?: string | null,
        sID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTemplatesQueryVariables = {
  filter?: ModelTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTemplatesQuery = {
  listTemplates?:  {
    __typename: "ModelTemplateConnection",
    items:  Array< {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTemplatesQueryVariables = {
  filter?: ModelTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTemplatesQuery = {
  syncTemplates?:  {
    __typename: "ModelTemplateConnection",
    items:  Array< {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type TemplatesByLIDAndUpdatedAtQueryVariables = {
  lID: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TemplatesByLIDAndUpdatedAtQuery = {
  templatesByLIDAndUpdatedAt?:  {
    __typename: "ModelTemplateConnection",
    items:  Array< {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTemplateSectionQueryVariables = {
  id: string,
};

export type GetTemplateSectionQuery = {
  getTemplateSection?:  {
    __typename: "TemplateSection",
    id: string,
    name: string,
    isSimple?: boolean | null,
    textboxes?:  {
      __typename: "ModelTemplateTextboxConnection",
      items:  Array< {
        __typename: "TemplateTextbox",
        id: string,
        value?: string | null,
        sID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    subsections?:  {
      __typename: "ModelTemplateSubsectionConnection",
      items:  Array< {
        __typename: "TemplateSubsection",
        id: string,
        name: string,
        sID: string,
        fieldOrder?: Array< string | null > | null,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    subsectionOrder?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTemplateSectionsQueryVariables = {
  filter?: ModelTemplateSectionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTemplateSectionsQuery = {
  listTemplateSections?:  {
    __typename: "ModelTemplateSectionConnection",
    items:  Array< {
      __typename: "TemplateSection",
      id: string,
      name: string,
      isSimple?: boolean | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      subsectionOrder?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTemplateSectionsQueryVariables = {
  filter?: ModelTemplateSectionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTemplateSectionsQuery = {
  syncTemplateSections?:  {
    __typename: "ModelTemplateSectionConnection",
    items:  Array< {
      __typename: "TemplateSection",
      id: string,
      name: string,
      isSimple?: boolean | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      subsectionOrder?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type TemplateSectionsByTIDAndUpdatedAtQueryVariables = {
  tID: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTemplateSectionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TemplateSectionsByTIDAndUpdatedAtQuery = {
  templateSectionsByTIDAndUpdatedAt?:  {
    __typename: "ModelTemplateSectionConnection",
    items:  Array< {
      __typename: "TemplateSection",
      id: string,
      name: string,
      isSimple?: boolean | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      subsectionOrder?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTemplateTextboxQueryVariables = {
  id: string,
};

export type GetTemplateTextboxQuery = {
  getTemplateTextbox?:  {
    __typename: "TemplateTextbox",
    id: string,
    value?: string | null,
    section?:  {
      __typename: "TemplateSection",
      id: string,
      name: string,
      isSimple?: boolean | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      subsectionOrder?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sID: string,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTemplateTextboxesQueryVariables = {
  filter?: ModelTemplateTextboxFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTemplateTextboxesQuery = {
  listTemplateTextboxes?:  {
    __typename: "ModelTemplateTextboxConnection",
    items:  Array< {
      __typename: "TemplateTextbox",
      id: string,
      value?: string | null,
      section?:  {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sID: string,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTemplateTextboxesQueryVariables = {
  filter?: ModelTemplateTextboxFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTemplateTextboxesQuery = {
  syncTemplateTextboxes?:  {
    __typename: "ModelTemplateTextboxConnection",
    items:  Array< {
      __typename: "TemplateTextbox",
      id: string,
      value?: string | null,
      section?:  {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sID: string,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type TemplateTextboxesBySIDAndUpdatedAtQueryVariables = {
  sID: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTemplateTextboxFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TemplateTextboxesBySIDAndUpdatedAtQuery = {
  templateTextboxesBySIDAndUpdatedAt?:  {
    __typename: "ModelTemplateTextboxConnection",
    items:  Array< {
      __typename: "TemplateTextbox",
      id: string,
      value?: string | null,
      section?:  {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sID: string,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type TemplateTextboxesByTIDAndUpdatedAtQueryVariables = {
  tID: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTemplateTextboxFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TemplateTextboxesByTIDAndUpdatedAtQuery = {
  templateTextboxesByTIDAndUpdatedAt?:  {
    __typename: "ModelTemplateTextboxConnection",
    items:  Array< {
      __typename: "TemplateTextbox",
      id: string,
      value?: string | null,
      section?:  {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sID: string,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTemplateSubsectionQueryVariables = {
  id: string,
};

export type GetTemplateSubsectionQuery = {
  getTemplateSubsection?:  {
    __typename: "TemplateSubsection",
    id: string,
    name: string,
    section?:  {
      __typename: "TemplateSection",
      id: string,
      name: string,
      isSimple?: boolean | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      subsectionOrder?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sID: string,
    fields?:  {
      __typename: "ModelTemplateFieldConnection",
      items:  Array< {
        __typename: "TemplateField",
        id: string,
        name: string,
        value?: string | null,
        ssID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    fieldOrder?: Array< string | null > | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTemplateSubsectionsQueryVariables = {
  filter?: ModelTemplateSubsectionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTemplateSubsectionsQuery = {
  listTemplateSubsections?:  {
    __typename: "ModelTemplateSubsectionConnection",
    items:  Array< {
      __typename: "TemplateSubsection",
      id: string,
      name: string,
      section?:  {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sID: string,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fieldOrder?: Array< string | null > | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTemplateSubsectionsQueryVariables = {
  filter?: ModelTemplateSubsectionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTemplateSubsectionsQuery = {
  syncTemplateSubsections?:  {
    __typename: "ModelTemplateSubsectionConnection",
    items:  Array< {
      __typename: "TemplateSubsection",
      id: string,
      name: string,
      section?:  {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sID: string,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fieldOrder?: Array< string | null > | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type TemplateSubsectionsBySIDAndUpdatedAtQueryVariables = {
  sID: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTemplateSubsectionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TemplateSubsectionsBySIDAndUpdatedAtQuery = {
  templateSubsectionsBySIDAndUpdatedAt?:  {
    __typename: "ModelTemplateSubsectionConnection",
    items:  Array< {
      __typename: "TemplateSubsection",
      id: string,
      name: string,
      section?:  {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sID: string,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fieldOrder?: Array< string | null > | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type TemplateSubsectionsByTIDAndUpdatedAtQueryVariables = {
  tID: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTemplateSubsectionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TemplateSubsectionsByTIDAndUpdatedAtQuery = {
  templateSubsectionsByTIDAndUpdatedAt?:  {
    __typename: "ModelTemplateSubsectionConnection",
    items:  Array< {
      __typename: "TemplateSubsection",
      id: string,
      name: string,
      section?:  {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sID: string,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fieldOrder?: Array< string | null > | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTemplateFieldQueryVariables = {
  id: string,
};

export type GetTemplateFieldQuery = {
  getTemplateField?:  {
    __typename: "TemplateField",
    id: string,
    name: string,
    value?: string | null,
    subsection?:  {
      __typename: "TemplateSubsection",
      id: string,
      name: string,
      section?:  {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sID: string,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fieldOrder?: Array< string | null > | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ssID: string,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTemplateFieldsQueryVariables = {
  filter?: ModelTemplateFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTemplateFieldsQuery = {
  listTemplateFields?:  {
    __typename: "ModelTemplateFieldConnection",
    items:  Array< {
      __typename: "TemplateField",
      id: string,
      name: string,
      value?: string | null,
      subsection?:  {
        __typename: "TemplateSubsection",
        id: string,
        name: string,
        sID: string,
        fieldOrder?: Array< string | null > | null,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      ssID: string,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTemplateFieldsQueryVariables = {
  filter?: ModelTemplateFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTemplateFieldsQuery = {
  syncTemplateFields?:  {
    __typename: "ModelTemplateFieldConnection",
    items:  Array< {
      __typename: "TemplateField",
      id: string,
      name: string,
      value?: string | null,
      subsection?:  {
        __typename: "TemplateSubsection",
        id: string,
        name: string,
        sID: string,
        fieldOrder?: Array< string | null > | null,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      ssID: string,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type TemplateFieldsBySsIDAndUpdatedAtQueryVariables = {
  ssID: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTemplateFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TemplateFieldsBySsIDAndUpdatedAtQuery = {
  templateFieldsBySsIDAndUpdatedAt?:  {
    __typename: "ModelTemplateFieldConnection",
    items:  Array< {
      __typename: "TemplateField",
      id: string,
      name: string,
      value?: string | null,
      subsection?:  {
        __typename: "TemplateSubsection",
        id: string,
        name: string,
        sID: string,
        fieldOrder?: Array< string | null > | null,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      ssID: string,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type TemplateFieldsByTIDAndUpdatedAtQueryVariables = {
  tID: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTemplateFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TemplateFieldsByTIDAndUpdatedAtQuery = {
  templateFieldsByTIDAndUpdatedAt?:  {
    __typename: "ModelTemplateFieldConnection",
    items:  Array< {
      __typename: "TemplateField",
      id: string,
      name: string,
      value?: string | null,
      subsection?:  {
        __typename: "TemplateSubsection",
        id: string,
        name: string,
        sID: string,
        fieldOrder?: Array< string | null > | null,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      ssID: string,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type OnCreateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  owner?: string | null,
};

export type OnCreateUserSubscription = {
  onCreateUser?:  {
    __typename: "User",
    id: string,
    email: string,
    name?: string | null,
    transcriptionTime?: number | null,
    transcriptionsCreated?: number | null,
    casesCreated?: number | null,
    templatesUsed?: number | null,
    currentTranscriptionsCreated?: number | null,
    currentCasesCreated?: number | null,
    currentTemplatesUsed?: number | null,
    storeReviewRequestedAt?: string | null,
    pims?: string | null,
    audioRetentionPeriod?: number | null,
    defaultNormalText?: string | null,
    stripeCustomerId?: string | null,
    groups?: Array< string | null > | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  owner?: string | null,
};

export type OnUpdateUserSubscription = {
  onUpdateUser?:  {
    __typename: "User",
    id: string,
    email: string,
    name?: string | null,
    transcriptionTime?: number | null,
    transcriptionsCreated?: number | null,
    casesCreated?: number | null,
    templatesUsed?: number | null,
    currentTranscriptionsCreated?: number | null,
    currentCasesCreated?: number | null,
    currentTemplatesUsed?: number | null,
    storeReviewRequestedAt?: string | null,
    pims?: string | null,
    audioRetentionPeriod?: number | null,
    defaultNormalText?: string | null,
    stripeCustomerId?: string | null,
    groups?: Array< string | null > | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
  owner?: string | null,
};

export type OnDeleteUserSubscription = {
  onDeleteUser?:  {
    __typename: "User",
    id: string,
    email: string,
    name?: string | null,
    transcriptionTime?: number | null,
    transcriptionsCreated?: number | null,
    casesCreated?: number | null,
    templatesUsed?: number | null,
    currentTranscriptionsCreated?: number | null,
    currentCasesCreated?: number | null,
    currentTemplatesUsed?: number | null,
    storeReviewRequestedAt?: string | null,
    pims?: string | null,
    audioRetentionPeriod?: number | null,
    defaultNormalText?: string | null,
    stripeCustomerId?: string | null,
    groups?: Array< string | null > | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateLocationSubscriptionVariables = {
  filter?: ModelSubscriptionLocationFilterInput | null,
};

export type OnCreateLocationSubscription = {
  onCreateLocation?:  {
    __typename: "Location",
    id: string,
    name: string,
    address?: string | null,
    patients?:  {
      __typename: "ModelPatientConnection",
      items:  Array< {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    templates?:  {
      __typename: "ModelTemplateConnection",
      items:  Array< {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    recordings?:  {
      __typename: "ModelRecordingConnection",
      items:  Array< {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    billingcodes?:  {
      __typename: "ModelBillingCodesConnection",
      items:  Array< {
        __typename: "BillingCodes",
        id: string,
        code?: string | null,
        description: string,
        keywords: Array< string | null >,
        price?: number | null,
        lID: string,
        groups?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groupUsers?: string | null,
    groupAdmins?: string | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateLocationSubscriptionVariables = {
  filter?: ModelSubscriptionLocationFilterInput | null,
};

export type OnUpdateLocationSubscription = {
  onUpdateLocation?:  {
    __typename: "Location",
    id: string,
    name: string,
    address?: string | null,
    patients?:  {
      __typename: "ModelPatientConnection",
      items:  Array< {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    templates?:  {
      __typename: "ModelTemplateConnection",
      items:  Array< {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    recordings?:  {
      __typename: "ModelRecordingConnection",
      items:  Array< {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    billingcodes?:  {
      __typename: "ModelBillingCodesConnection",
      items:  Array< {
        __typename: "BillingCodes",
        id: string,
        code?: string | null,
        description: string,
        keywords: Array< string | null >,
        price?: number | null,
        lID: string,
        groups?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groupUsers?: string | null,
    groupAdmins?: string | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteLocationSubscriptionVariables = {
  filter?: ModelSubscriptionLocationFilterInput | null,
};

export type OnDeleteLocationSubscription = {
  onDeleteLocation?:  {
    __typename: "Location",
    id: string,
    name: string,
    address?: string | null,
    patients?:  {
      __typename: "ModelPatientConnection",
      items:  Array< {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    templates?:  {
      __typename: "ModelTemplateConnection",
      items:  Array< {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    recordings?:  {
      __typename: "ModelRecordingConnection",
      items:  Array< {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    billingcodes?:  {
      __typename: "ModelBillingCodesConnection",
      items:  Array< {
        __typename: "BillingCodes",
        id: string,
        code?: string | null,
        description: string,
        keywords: Array< string | null >,
        price?: number | null,
        lID: string,
        groups?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groupUsers?: string | null,
    groupAdmins?: string | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreatePatientSubscriptionVariables = {
  filter?: ModelSubscriptionPatientFilterInput | null,
};

export type OnCreatePatientSubscription = {
  onCreatePatient?:  {
    __typename: "Patient",
    id: string,
    name: string,
    client?: string | null,
    image?: string | null,
    s3Image?: string | null,
    pinned?: boolean | null,
    archived?: boolean | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    cases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    details?:  {
      __typename: "ModelDetailsConnection",
      items:  Array< {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdatePatientSubscriptionVariables = {
  filter?: ModelSubscriptionPatientFilterInput | null,
};

export type OnUpdatePatientSubscription = {
  onUpdatePatient?:  {
    __typename: "Patient",
    id: string,
    name: string,
    client?: string | null,
    image?: string | null,
    s3Image?: string | null,
    pinned?: boolean | null,
    archived?: boolean | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    cases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    details?:  {
      __typename: "ModelDetailsConnection",
      items:  Array< {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeletePatientSubscriptionVariables = {
  filter?: ModelSubscriptionPatientFilterInput | null,
};

export type OnDeletePatientSubscription = {
  onDeletePatient?:  {
    __typename: "Patient",
    id: string,
    name: string,
    client?: string | null,
    image?: string | null,
    s3Image?: string | null,
    pinned?: boolean | null,
    archived?: boolean | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    cases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    details?:  {
      __typename: "ModelDetailsConnection",
      items:  Array< {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateCaseSubscriptionVariables = {
  filter?: ModelSubscriptionCaseFilterInput | null,
};

export type OnCreateCaseSubscription = {
  onCreateCase?:  {
    __typename: "Case",
    id: string,
    title: string,
    description?: string | null,
    historySummary?: string | null,
    planSummary?: string | null,
    communicationSummary?: string | null,
    overviewSummary?: string | null,
    typedNotes?: string | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    caseTemplateId?: string | null,
    templateData?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID?: string | null,
    patient?:  {
      __typename: "Patient",
      id: string,
      name: string,
      client?: string | null,
      image?: string | null,
      s3Image?: string | null,
      pinned?: boolean | null,
      archived?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    pID?: string | null,
    details?:  {
      __typename: "ModelDetailsConnection",
      items:  Array< {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    recordings?:  {
      __typename: "ModelRecordingConnection",
      items:  Array< {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateCaseSubscriptionVariables = {
  filter?: ModelSubscriptionCaseFilterInput | null,
};

export type OnUpdateCaseSubscription = {
  onUpdateCase?:  {
    __typename: "Case",
    id: string,
    title: string,
    description?: string | null,
    historySummary?: string | null,
    planSummary?: string | null,
    communicationSummary?: string | null,
    overviewSummary?: string | null,
    typedNotes?: string | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    caseTemplateId?: string | null,
    templateData?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID?: string | null,
    patient?:  {
      __typename: "Patient",
      id: string,
      name: string,
      client?: string | null,
      image?: string | null,
      s3Image?: string | null,
      pinned?: boolean | null,
      archived?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    pID?: string | null,
    details?:  {
      __typename: "ModelDetailsConnection",
      items:  Array< {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    recordings?:  {
      __typename: "ModelRecordingConnection",
      items:  Array< {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteCaseSubscriptionVariables = {
  filter?: ModelSubscriptionCaseFilterInput | null,
};

export type OnDeleteCaseSubscription = {
  onDeleteCase?:  {
    __typename: "Case",
    id: string,
    title: string,
    description?: string | null,
    historySummary?: string | null,
    planSummary?: string | null,
    communicationSummary?: string | null,
    overviewSummary?: string | null,
    typedNotes?: string | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    caseTemplateId?: string | null,
    templateData?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID?: string | null,
    patient?:  {
      __typename: "Patient",
      id: string,
      name: string,
      client?: string | null,
      image?: string | null,
      s3Image?: string | null,
      pinned?: boolean | null,
      archived?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    pID?: string | null,
    details?:  {
      __typename: "ModelDetailsConnection",
      items:  Array< {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    recordings?:  {
      __typename: "ModelRecordingConnection",
      items:  Array< {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateDetailsSubscriptionVariables = {
  filter?: ModelSubscriptionDetailsFilterInput | null,
};

export type OnCreateDetailsSubscription = {
  onCreateDetails?:  {
    __typename: "Details",
    id: string,
    type?: DetailsType | null,
    text?: string | null,
    summary?: string | null,
    isSummarized?: boolean | null,
    patient?:  {
      __typename: "Patient",
      id: string,
      name: string,
      client?: string | null,
      image?: string | null,
      s3Image?: string | null,
      pinned?: boolean | null,
      archived?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    pID: string,
    case?:  {
      __typename: "Case",
      id: string,
      title: string,
      description?: string | null,
      historySummary?: string | null,
      planSummary?: string | null,
      communicationSummary?: string | null,
      overviewSummary?: string | null,
      typedNotes?: string | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      caseTemplateId?: string | null,
      templateData?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID?: string | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    cID: string,
    recording?:  {
      __typename: "Recording",
      id: string,
      name?: string | null,
      storagePath?: string | null,
      useTemplate?: boolean | null,
      duration?: number | null,
      text?: string | null,
      segments?: string | null,
      summary?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID?: string | null,
      details?:  {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null,
      dID?: string | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    detailsRecordingId?: string | null,
  } | null,
};

export type OnUpdateDetailsSubscriptionVariables = {
  filter?: ModelSubscriptionDetailsFilterInput | null,
};

export type OnUpdateDetailsSubscription = {
  onUpdateDetails?:  {
    __typename: "Details",
    id: string,
    type?: DetailsType | null,
    text?: string | null,
    summary?: string | null,
    isSummarized?: boolean | null,
    patient?:  {
      __typename: "Patient",
      id: string,
      name: string,
      client?: string | null,
      image?: string | null,
      s3Image?: string | null,
      pinned?: boolean | null,
      archived?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    pID: string,
    case?:  {
      __typename: "Case",
      id: string,
      title: string,
      description?: string | null,
      historySummary?: string | null,
      planSummary?: string | null,
      communicationSummary?: string | null,
      overviewSummary?: string | null,
      typedNotes?: string | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      caseTemplateId?: string | null,
      templateData?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID?: string | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    cID: string,
    recording?:  {
      __typename: "Recording",
      id: string,
      name?: string | null,
      storagePath?: string | null,
      useTemplate?: boolean | null,
      duration?: number | null,
      text?: string | null,
      segments?: string | null,
      summary?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID?: string | null,
      details?:  {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null,
      dID?: string | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    detailsRecordingId?: string | null,
  } | null,
};

export type OnDeleteDetailsSubscriptionVariables = {
  filter?: ModelSubscriptionDetailsFilterInput | null,
};

export type OnDeleteDetailsSubscription = {
  onDeleteDetails?:  {
    __typename: "Details",
    id: string,
    type?: DetailsType | null,
    text?: string | null,
    summary?: string | null,
    isSummarized?: boolean | null,
    patient?:  {
      __typename: "Patient",
      id: string,
      name: string,
      client?: string | null,
      image?: string | null,
      s3Image?: string | null,
      pinned?: boolean | null,
      archived?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    pID: string,
    case?:  {
      __typename: "Case",
      id: string,
      title: string,
      description?: string | null,
      historySummary?: string | null,
      planSummary?: string | null,
      communicationSummary?: string | null,
      overviewSummary?: string | null,
      typedNotes?: string | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      caseTemplateId?: string | null,
      templateData?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID?: string | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    cID: string,
    recording?:  {
      __typename: "Recording",
      id: string,
      name?: string | null,
      storagePath?: string | null,
      useTemplate?: boolean | null,
      duration?: number | null,
      text?: string | null,
      segments?: string | null,
      summary?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID?: string | null,
      details?:  {
        __typename: "Details",
        id: string,
        type?: DetailsType | null,
        text?: string | null,
        summary?: string | null,
        isSummarized?: boolean | null,
        pID: string,
        cID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        detailsRecordingId?: string | null,
      } | null,
      dID?: string | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    groups?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    detailsRecordingId?: string | null,
  } | null,
};

export type OnCreateRecordingSubscriptionVariables = {
  filter?: ModelSubscriptionRecordingFilterInput | null,
};

export type OnCreateRecordingSubscription = {
  onCreateRecording?:  {
    __typename: "Recording",
    id: string,
    name?: string | null,
    storagePath?: string | null,
    useTemplate?: boolean | null,
    duration?: number | null,
    text?: string | null,
    segments?: string | null,
    summary?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID?: string | null,
    case?:  {
      __typename: "Case",
      id: string,
      title: string,
      description?: string | null,
      historySummary?: string | null,
      planSummary?: string | null,
      communicationSummary?: string | null,
      overviewSummary?: string | null,
      typedNotes?: string | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      caseTemplateId?: string | null,
      templateData?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID?: string | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    cID?: string | null,
    details?:  {
      __typename: "Details",
      id: string,
      type?: DetailsType | null,
      text?: string | null,
      summary?: string | null,
      isSummarized?: boolean | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID: string,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID: string,
      recording?:  {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      detailsRecordingId?: string | null,
    } | null,
    dID?: string | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateRecordingSubscriptionVariables = {
  filter?: ModelSubscriptionRecordingFilterInput | null,
};

export type OnUpdateRecordingSubscription = {
  onUpdateRecording?:  {
    __typename: "Recording",
    id: string,
    name?: string | null,
    storagePath?: string | null,
    useTemplate?: boolean | null,
    duration?: number | null,
    text?: string | null,
    segments?: string | null,
    summary?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID?: string | null,
    case?:  {
      __typename: "Case",
      id: string,
      title: string,
      description?: string | null,
      historySummary?: string | null,
      planSummary?: string | null,
      communicationSummary?: string | null,
      overviewSummary?: string | null,
      typedNotes?: string | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      caseTemplateId?: string | null,
      templateData?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID?: string | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    cID?: string | null,
    details?:  {
      __typename: "Details",
      id: string,
      type?: DetailsType | null,
      text?: string | null,
      summary?: string | null,
      isSummarized?: boolean | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID: string,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID: string,
      recording?:  {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      detailsRecordingId?: string | null,
    } | null,
    dID?: string | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteRecordingSubscriptionVariables = {
  filter?: ModelSubscriptionRecordingFilterInput | null,
};

export type OnDeleteRecordingSubscription = {
  onDeleteRecording?:  {
    __typename: "Recording",
    id: string,
    name?: string | null,
    storagePath?: string | null,
    useTemplate?: boolean | null,
    duration?: number | null,
    text?: string | null,
    segments?: string | null,
    summary?: string | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID?: string | null,
    case?:  {
      __typename: "Case",
      id: string,
      title: string,
      description?: string | null,
      historySummary?: string | null,
      planSummary?: string | null,
      communicationSummary?: string | null,
      overviewSummary?: string | null,
      typedNotes?: string | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      caseTemplateId?: string | null,
      templateData?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID?: string | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID?: string | null,
      details?:  {
        __typename: "ModelDetailsConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    cID?: string | null,
    details?:  {
      __typename: "Details",
      id: string,
      type?: DetailsType | null,
      text?: string | null,
      summary?: string | null,
      isSummarized?: boolean | null,
      patient?:  {
        __typename: "Patient",
        id: string,
        name: string,
        client?: string | null,
        image?: string | null,
        s3Image?: string | null,
        pinned?: boolean | null,
        archived?: boolean | null,
        lID: string,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      pID: string,
      case?:  {
        __typename: "Case",
        id: string,
        title: string,
        description?: string | null,
        historySummary?: string | null,
        planSummary?: string | null,
        communicationSummary?: string | null,
        overviewSummary?: string | null,
        typedNotes?: string | null,
        caseTemplateId?: string | null,
        templateData?: string | null,
        lID?: string | null,
        pID?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      cID: string,
      recording?:  {
        __typename: "Recording",
        id: string,
        name?: string | null,
        storagePath?: string | null,
        useTemplate?: boolean | null,
        duration?: number | null,
        text?: string | null,
        segments?: string | null,
        summary?: string | null,
        lID?: string | null,
        cID?: string | null,
        dID?: string | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      detailsRecordingId?: string | null,
    } | null,
    dID?: string | null,
    owners?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateBillingCodesSubscriptionVariables = {
  filter?: ModelSubscriptionBillingCodesFilterInput | null,
};

export type OnCreateBillingCodesSubscription = {
  onCreateBillingCodes?:  {
    __typename: "BillingCodes",
    id: string,
    code?: string | null,
    description: string,
    keywords: Array< string | null >,
    price?: number | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    groups?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateBillingCodesSubscriptionVariables = {
  filter?: ModelSubscriptionBillingCodesFilterInput | null,
};

export type OnUpdateBillingCodesSubscription = {
  onUpdateBillingCodes?:  {
    __typename: "BillingCodes",
    id: string,
    code?: string | null,
    description: string,
    keywords: Array< string | null >,
    price?: number | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    groups?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteBillingCodesSubscriptionVariables = {
  filter?: ModelSubscriptionBillingCodesFilterInput | null,
};

export type OnDeleteBillingCodesSubscription = {
  onDeleteBillingCodes?:  {
    __typename: "BillingCodes",
    id: string,
    code?: string | null,
    description: string,
    keywords: Array< string | null >,
    price?: number | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    groups?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionTemplateFilterInput | null,
};

export type OnCreateTemplateSubscription = {
  onCreateTemplate?:  {
    __typename: "Template",
    id: string,
    name: string,
    pinned?: boolean | null,
    archived?: boolean | null,
    advanced?: boolean | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    sections?:  {
      __typename: "ModelTemplateSectionConnection",
      items:  Array< {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    sectionOrder?: Array< string | null > | null,
    subsections?:  {
      __typename: "ModelTemplateSubsectionConnection",
      items:  Array< {
        __typename: "TemplateSubsection",
        id: string,
        name: string,
        sID: string,
        fieldOrder?: Array< string | null > | null,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    fields?:  {
      __typename: "ModelTemplateFieldConnection",
      items:  Array< {
        __typename: "TemplateField",
        id: string,
        name: string,
        value?: string | null,
        ssID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    textboxes?:  {
      __typename: "ModelTemplateTextboxConnection",
      items:  Array< {
        __typename: "TemplateTextbox",
        id: string,
        value?: string | null,
        sID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionTemplateFilterInput | null,
};

export type OnUpdateTemplateSubscription = {
  onUpdateTemplate?:  {
    __typename: "Template",
    id: string,
    name: string,
    pinned?: boolean | null,
    archived?: boolean | null,
    advanced?: boolean | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    sections?:  {
      __typename: "ModelTemplateSectionConnection",
      items:  Array< {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    sectionOrder?: Array< string | null > | null,
    subsections?:  {
      __typename: "ModelTemplateSubsectionConnection",
      items:  Array< {
        __typename: "TemplateSubsection",
        id: string,
        name: string,
        sID: string,
        fieldOrder?: Array< string | null > | null,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    fields?:  {
      __typename: "ModelTemplateFieldConnection",
      items:  Array< {
        __typename: "TemplateField",
        id: string,
        name: string,
        value?: string | null,
        ssID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    textboxes?:  {
      __typename: "ModelTemplateTextboxConnection",
      items:  Array< {
        __typename: "TemplateTextbox",
        id: string,
        value?: string | null,
        sID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionTemplateFilterInput | null,
};

export type OnDeleteTemplateSubscription = {
  onDeleteTemplate?:  {
    __typename: "Template",
    id: string,
    name: string,
    pinned?: boolean | null,
    archived?: boolean | null,
    advanced?: boolean | null,
    location?:  {
      __typename: "Location",
      id: string,
      name: string,
      address?: string | null,
      patients?:  {
        __typename: "ModelPatientConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      templates?:  {
        __typename: "ModelTemplateConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      recordings?:  {
        __typename: "ModelRecordingConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      billingcodes?:  {
        __typename: "ModelBillingCodesConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      groupUsers?: string | null,
      groupAdmins?: string | null,
      groups?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    lID: string,
    sections?:  {
      __typename: "ModelTemplateSectionConnection",
      items:  Array< {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    sectionOrder?: Array< string | null > | null,
    subsections?:  {
      __typename: "ModelTemplateSubsectionConnection",
      items:  Array< {
        __typename: "TemplateSubsection",
        id: string,
        name: string,
        sID: string,
        fieldOrder?: Array< string | null > | null,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    fields?:  {
      __typename: "ModelTemplateFieldConnection",
      items:  Array< {
        __typename: "TemplateField",
        id: string,
        name: string,
        value?: string | null,
        ssID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    textboxes?:  {
      __typename: "ModelTemplateTextboxConnection",
      items:  Array< {
        __typename: "TemplateTextbox",
        id: string,
        value?: string | null,
        sID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTemplateSectionSubscriptionVariables = {
  filter?: ModelSubscriptionTemplateSectionFilterInput | null,
};

export type OnCreateTemplateSectionSubscription = {
  onCreateTemplateSection?:  {
    __typename: "TemplateSection",
    id: string,
    name: string,
    isSimple?: boolean | null,
    textboxes?:  {
      __typename: "ModelTemplateTextboxConnection",
      items:  Array< {
        __typename: "TemplateTextbox",
        id: string,
        value?: string | null,
        sID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    subsections?:  {
      __typename: "ModelTemplateSubsectionConnection",
      items:  Array< {
        __typename: "TemplateSubsection",
        id: string,
        name: string,
        sID: string,
        fieldOrder?: Array< string | null > | null,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    subsectionOrder?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTemplateSectionSubscriptionVariables = {
  filter?: ModelSubscriptionTemplateSectionFilterInput | null,
};

export type OnUpdateTemplateSectionSubscription = {
  onUpdateTemplateSection?:  {
    __typename: "TemplateSection",
    id: string,
    name: string,
    isSimple?: boolean | null,
    textboxes?:  {
      __typename: "ModelTemplateTextboxConnection",
      items:  Array< {
        __typename: "TemplateTextbox",
        id: string,
        value?: string | null,
        sID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    subsections?:  {
      __typename: "ModelTemplateSubsectionConnection",
      items:  Array< {
        __typename: "TemplateSubsection",
        id: string,
        name: string,
        sID: string,
        fieldOrder?: Array< string | null > | null,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    subsectionOrder?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTemplateSectionSubscriptionVariables = {
  filter?: ModelSubscriptionTemplateSectionFilterInput | null,
};

export type OnDeleteTemplateSectionSubscription = {
  onDeleteTemplateSection?:  {
    __typename: "TemplateSection",
    id: string,
    name: string,
    isSimple?: boolean | null,
    textboxes?:  {
      __typename: "ModelTemplateTextboxConnection",
      items:  Array< {
        __typename: "TemplateTextbox",
        id: string,
        value?: string | null,
        sID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    subsections?:  {
      __typename: "ModelTemplateSubsectionConnection",
      items:  Array< {
        __typename: "TemplateSubsection",
        id: string,
        name: string,
        sID: string,
        fieldOrder?: Array< string | null > | null,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    subsectionOrder?: Array< string | null > | null,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTemplateTextboxSubscriptionVariables = {
  filter?: ModelSubscriptionTemplateTextboxFilterInput | null,
};

export type OnCreateTemplateTextboxSubscription = {
  onCreateTemplateTextbox?:  {
    __typename: "TemplateTextbox",
    id: string,
    value?: string | null,
    section?:  {
      __typename: "TemplateSection",
      id: string,
      name: string,
      isSimple?: boolean | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      subsectionOrder?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sID: string,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTemplateTextboxSubscriptionVariables = {
  filter?: ModelSubscriptionTemplateTextboxFilterInput | null,
};

export type OnUpdateTemplateTextboxSubscription = {
  onUpdateTemplateTextbox?:  {
    __typename: "TemplateTextbox",
    id: string,
    value?: string | null,
    section?:  {
      __typename: "TemplateSection",
      id: string,
      name: string,
      isSimple?: boolean | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      subsectionOrder?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sID: string,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTemplateTextboxSubscriptionVariables = {
  filter?: ModelSubscriptionTemplateTextboxFilterInput | null,
};

export type OnDeleteTemplateTextboxSubscription = {
  onDeleteTemplateTextbox?:  {
    __typename: "TemplateTextbox",
    id: string,
    value?: string | null,
    section?:  {
      __typename: "TemplateSection",
      id: string,
      name: string,
      isSimple?: boolean | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      subsectionOrder?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sID: string,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTemplateSubsectionSubscriptionVariables = {
  filter?: ModelSubscriptionTemplateSubsectionFilterInput | null,
};

export type OnCreateTemplateSubsectionSubscription = {
  onCreateTemplateSubsection?:  {
    __typename: "TemplateSubsection",
    id: string,
    name: string,
    section?:  {
      __typename: "TemplateSection",
      id: string,
      name: string,
      isSimple?: boolean | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      subsectionOrder?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sID: string,
    fields?:  {
      __typename: "ModelTemplateFieldConnection",
      items:  Array< {
        __typename: "TemplateField",
        id: string,
        name: string,
        value?: string | null,
        ssID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    fieldOrder?: Array< string | null > | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTemplateSubsectionSubscriptionVariables = {
  filter?: ModelSubscriptionTemplateSubsectionFilterInput | null,
};

export type OnUpdateTemplateSubsectionSubscription = {
  onUpdateTemplateSubsection?:  {
    __typename: "TemplateSubsection",
    id: string,
    name: string,
    section?:  {
      __typename: "TemplateSection",
      id: string,
      name: string,
      isSimple?: boolean | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      subsectionOrder?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sID: string,
    fields?:  {
      __typename: "ModelTemplateFieldConnection",
      items:  Array< {
        __typename: "TemplateField",
        id: string,
        name: string,
        value?: string | null,
        ssID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    fieldOrder?: Array< string | null > | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTemplateSubsectionSubscriptionVariables = {
  filter?: ModelSubscriptionTemplateSubsectionFilterInput | null,
};

export type OnDeleteTemplateSubsectionSubscription = {
  onDeleteTemplateSubsection?:  {
    __typename: "TemplateSubsection",
    id: string,
    name: string,
    section?:  {
      __typename: "TemplateSection",
      id: string,
      name: string,
      isSimple?: boolean | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      subsectionOrder?: Array< string | null > | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    sID: string,
    fields?:  {
      __typename: "ModelTemplateFieldConnection",
      items:  Array< {
        __typename: "TemplateField",
        id: string,
        name: string,
        value?: string | null,
        ssID: string,
        tID: string,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    fieldOrder?: Array< string | null > | null,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTemplateFieldSubscriptionVariables = {
  filter?: ModelSubscriptionTemplateFieldFilterInput | null,
};

export type OnCreateTemplateFieldSubscription = {
  onCreateTemplateField?:  {
    __typename: "TemplateField",
    id: string,
    name: string,
    value?: string | null,
    subsection?:  {
      __typename: "TemplateSubsection",
      id: string,
      name: string,
      section?:  {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sID: string,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fieldOrder?: Array< string | null > | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ssID: string,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTemplateFieldSubscriptionVariables = {
  filter?: ModelSubscriptionTemplateFieldFilterInput | null,
};

export type OnUpdateTemplateFieldSubscription = {
  onUpdateTemplateField?:  {
    __typename: "TemplateField",
    id: string,
    name: string,
    value?: string | null,
    subsection?:  {
      __typename: "TemplateSubsection",
      id: string,
      name: string,
      section?:  {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sID: string,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fieldOrder?: Array< string | null > | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ssID: string,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTemplateFieldSubscriptionVariables = {
  filter?: ModelSubscriptionTemplateFieldFilterInput | null,
};

export type OnDeleteTemplateFieldSubscription = {
  onDeleteTemplateField?:  {
    __typename: "TemplateField",
    id: string,
    name: string,
    value?: string | null,
    subsection?:  {
      __typename: "TemplateSubsection",
      id: string,
      name: string,
      section?:  {
        __typename: "TemplateSection",
        id: string,
        name: string,
        isSimple?: boolean | null,
        tID: string,
        subsectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      sID: string,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fieldOrder?: Array< string | null > | null,
      template?:  {
        __typename: "Template",
        id: string,
        name: string,
        pinned?: boolean | null,
        archived?: boolean | null,
        advanced?: boolean | null,
        lID: string,
        sectionOrder?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        updatedAt: string,
        createdAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      tID: string,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    ssID: string,
    template?:  {
      __typename: "Template",
      id: string,
      name: string,
      pinned?: boolean | null,
      archived?: boolean | null,
      advanced?: boolean | null,
      location?:  {
        __typename: "Location",
        id: string,
        name: string,
        address?: string | null,
        groupUsers?: string | null,
        groupAdmins?: string | null,
        groups?: Array< string | null > | null,
        owners?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      lID: string,
      sections?:  {
        __typename: "ModelTemplateSectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      sectionOrder?: Array< string | null > | null,
      subsections?:  {
        __typename: "ModelTemplateSubsectionConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      fields?:  {
        __typename: "ModelTemplateFieldConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      textboxes?:  {
        __typename: "ModelTemplateTextboxConnection",
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      owners?: Array< string | null > | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    tID: string,
    owners?: Array< string | null > | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};
